(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc3d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc3d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9ck0s", function(module, exports) {

var $aRmx5 = parcelRequire("aRmx5");
"use strict";
function e(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
    value: !0
});

var $8NKT3 = parcelRequire("8NKT3");

var $l1o0O = parcelRequire("l1o0O");

var i = e((parcelRequire("7P6xi")));

var n = e((parcelRequire("2YySW")));

var $5lUdl = parcelRequire("5lUdl");
var a = function a1() {
    return (a = Object.assign || function(e) {
        for(var t, r = 1, i = arguments.length; r < i; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }).apply(this, arguments);
};
function s() {
    for(var _$e = 0, t = 0, r = arguments.length; t < r; t++)_$e += arguments[t].length;
    var i = Array(_$e), n = 0;
    for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, s = o.length; a < s; a++, n++)i[n] = o[a];
    return i;
}
var u = Math.pow(2, 53);
function l(e) {
    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
    if (!e) return {};
    if ("function" == typeof Object.assign) return Object.assign.apply(Object, s([
        e
    ], t));
    for(var i = Object(e), n = 0; n < t.length; n++){
        var o = t[n];
        if (null != o) for(var a in o)Object.prototype.hasOwnProperty.call(o, a) && (i[a] = o[a]);
    }
    return i;
}
function E(e, t) {
    return e ? d(e, function(e) {
        return e[t];
    }) : {};
}
function I(e) {
    return Object.keys(e).map(function(t) {
        return e[t];
    });
}
function c(e) {
    return Object.keys(e).map(function(t) {
        return [
            t,
            e[t]
        ];
    });
}
function _(e, t) {
    for(var r, i = 0, n = e; i < n.length; i++){
        var o = n[i];
        if (t(o)) {
            r = o;
            break;
        }
    }
    return r;
}
function d(e, t) {
    var r = {};
    return e.forEach(function(e) {
        var i = t(e);
        r[i] = e;
    }), r;
}
function f(e) {
    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
    var i = 0;
    return e.replace(/%s/g, function() {
        var _$e = t[i++], r = typeof _$e === "undefined" ? "undefined" : (0, $aRmx5._)(_$e);
        return "function" === r ? _$e() : "string" === r ? _$e : String(_$e);
    });
}
var g, p = {
    assign: l,
    currentTimestamp: function currentTimestamp() {
        return Math.round((new Date).getTime());
    },
    isSafeInteger: function isSafeInteger(e) {
        return "number" == typeof e && Math.abs(e) <= u;
    },
    keyBy: E,
    uuid: function uuid() {
        return i();
    },
    isNumber: function isNumber(e) {
        return "number" == typeof e;
    },
    getTimestamp: function getTimestamp() {
        return (new Date).getTime();
    },
    isValidEnum: function isValidEnum(e, t) {
        for(var r = !1, i = Object.keys(e), n = 0; n < i.length; n++)if (t === e[i[n]]) {
            r = !0;
            break;
        }
        return r;
    },
    groupBy: function groupBy(e, t) {
        var r = {};
        return e.forEach(function(e) {
            var i = t(e);
            r[i] = r[i] || [], r[i].push(e);
        }), I(r);
    },
    objectValues: I,
    objectEntries: c,
    find: _,
    keyByUtil: d,
    sprintf: f
}, O = {
    NOTSET: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4
}, N = {
    CONDITION_EVALUATOR_ERROR: "%s: Error evaluating audience condition of type %s: %s",
    DATAFILE_AND_SDK_KEY_MISSING: "%s: You must provide at least one of sdkKey or datafile. Cannot start Optimizely",
    EXPERIMENT_KEY_NOT_IN_DATAFILE: "%s: Experiment key %s is not in datafile.",
    FEATURE_NOT_IN_DATAFILE: "%s: Feature key %s is not in datafile.",
    IMPROPERLY_FORMATTED_EXPERIMENT: "%s: Experiment key %s is improperly formatted.",
    INVALID_ATTRIBUTES: "%s: Provided attributes are in an invalid format.",
    INVALID_BUCKETING_ID: "%s: Unable to generate hash for bucketing ID %s: %s",
    INVALID_DATAFILE: "%s: Datafile is invalid - property %s: %s",
    INVALID_DATAFILE_MALFORMED: "%s: Datafile is invalid because it is malformed.",
    INVALID_CONFIG: "%s: Provided Optimizely config is in an invalid format.",
    INVALID_JSON: "%s: JSON object is not valid.",
    INVALID_ERROR_HANDLER: '%s: Provided "errorHandler" is in an invalid format.',
    INVALID_EVENT_DISPATCHER: '%s: Provided "eventDispatcher" is in an invalid format.',
    INVALID_EVENT_TAGS: "%s: Provided event tags are in an invalid format.",
    INVALID_EXPERIMENT_KEY: "%s: Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
    INVALID_EXPERIMENT_ID: "%s: Experiment ID %s is not in datafile.",
    INVALID_GROUP_ID: "%s: Group ID %s is not in datafile.",
    INVALID_LOGGER: '%s: Provided "logger" is in an invalid format.',
    INVALID_ROLLOUT_ID: "%s: Invalid rollout ID %s attached to feature %s",
    INVALID_USER_ID: "%s: Provided user ID is in an invalid format.",
    INVALID_USER_PROFILE_SERVICE: "%s: Provided user profile service instance is in an invalid format: %s.",
    NO_DATAFILE_SPECIFIED: "%s: No datafile specified. Cannot start optimizely.",
    NO_JSON_PROVIDED: "%s: No JSON object to validate against schema.",
    NO_VARIATION_FOR_EXPERIMENT_KEY: "%s: No variation key %s defined in datafile for experiment %s.",
    UNDEFINED_ATTRIBUTE: "%s: Provided attribute: %s has an undefined value.",
    UNRECOGNIZED_ATTRIBUTE: "%s: Unrecognized attribute %s provided. Pruning before sending event to Optimizely.",
    UNABLE_TO_CAST_VALUE: "%s: Unable to cast value %s to type %s, returning null.",
    USER_NOT_IN_FORCED_VARIATION: "%s: User %s is not in the forced variation map. Cannot remove their forced variation.",
    USER_PROFILE_LOOKUP_ERROR: '%s: Error while looking up user profile for user ID "%s": %s.',
    USER_PROFILE_SAVE_ERROR: '%s: Error while saving user profile for user ID "%s": %s.',
    VARIABLE_KEY_NOT_IN_DATAFILE: '%s: Variable with key "%s" associated with feature with key "%s" is not in datafile.',
    VARIATION_ID_NOT_IN_DATAFILE: "%s: No variation ID %s defined in datafile for experiment %s.",
    VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT: "%s: Variation ID %s is not in the datafile.",
    INVALID_INPUT_FORMAT: "%s: Provided %s is in an invalid format.",
    INVALID_DATAFILE_VERSION: "%s: This version of the JavaScript SDK does not support the given datafile version: %s",
    INVALID_VARIATION_KEY: "%s: Provided variation key is in an invalid format."
}, R = {
    ACTIVATE_USER: "%s: Activating user %s in experiment %s.",
    DISPATCH_CONVERSION_EVENT: "%s: Dispatching conversion event to URL %s with params %s.",
    DISPATCH_IMPRESSION_EVENT: "%s: Dispatching impression event to URL %s with params %s.",
    DEPRECATED_EVENT_VALUE: "%s: Event value is deprecated in %s call.",
    EVENT_KEY_NOT_FOUND: "%s: Event key %s is not in datafile.",
    EXPERIMENT_NOT_RUNNING: "%s: Experiment %s is not running.",
    FEATURE_ENABLED_FOR_USER: "%s: Feature %s is enabled for user %s.",
    FEATURE_NOT_ENABLED_FOR_USER: "%s: Feature %s is not enabled for user %s.",
    FEATURE_HAS_NO_EXPERIMENTS: "%s: Feature %s is not attached to any experiments.",
    FAILED_TO_PARSE_VALUE: '%s: Failed to parse event value "%s" from event tags.',
    FAILED_TO_PARSE_REVENUE: '%s: Failed to parse revenue value "%s" from event tags.',
    FORCED_BUCKETING_FAILED: "%s: Variation key %s is not in datafile. Not activating user %s.",
    INVALID_OBJECT: "%s: Optimizely object is not valid. Failing %s.",
    INVALID_CLIENT_ENGINE: "%s: Invalid client engine passed: %s. Defaulting to node-sdk.",
    INVALID_DEFAULT_DECIDE_OPTIONS: "%s: Provided default decide options is not an array.",
    INVALID_DECIDE_OPTIONS: "%s: Provided decide options is not an array. Using default decide options.",
    INVALID_VARIATION_ID: "%s: Bucketed into an invalid variation ID. Returning null.",
    NOTIFICATION_LISTENER_EXCEPTION: "%s: Notification listener for (%s) threw exception: %s",
    NO_ROLLOUT_EXISTS: "%s: There is no rollout of feature %s.",
    NOT_ACTIVATING_USER: "%s: Not activating user %s for experiment %s.",
    NOT_TRACKING_USER: "%s: Not tracking user %s.",
    PARSED_REVENUE_VALUE: '%s: Parsed revenue value "%s" from event tags.',
    PARSED_NUMERIC_VALUE: '%s: Parsed event value "%s" from event tags.',
    RETURNING_STORED_VARIATION: '%s: Returning previously activated variation "%s" of experiment "%s" for user "%s" from user profile.',
    ROLLOUT_HAS_NO_EXPERIMENTS: "%s: Rollout of feature %s has no experiments",
    SAVED_VARIATION: '%s: Saved variation "%s" of experiment "%s" for user "%s".',
    SAVED_VARIATION_NOT_FOUND: "%s: User %s was previously bucketed into variation with ID %s for experiment %s, but no matching variation was found.",
    SHOULD_NOT_DISPATCH_ACTIVATE: '%s: Experiment %s is not in "Running" state. Not activating user.',
    SKIPPING_JSON_VALIDATION: "%s: Skipping JSON schema validation.",
    TRACK_EVENT: "%s: Tracking event %s for user %s.",
    UNRECOGNIZED_DECIDE_OPTION: "%s: Unrecognized decide option %s provided.",
    USER_ASSIGNED_TO_EXPERIMENT_BUCKET: "%s: Assigned bucket %s to user with bucketing ID %s.",
    USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is in experiment %s of group %s.",
    USER_BUCKETED_INTO_TARGETING_RULE: "%s: User %s bucketed into targeting rule %s.",
    USER_IN_FEATURE_EXPERIMENT: "%s: User %s is in variation %s of experiment %s on the feature %s.",
    USER_IN_ROLLOUT: "%s: User %s is in rollout of feature %s.",
    USER_NOT_BUCKETED_INTO_EVERYONE_TARGETING_RULE: "%s: User %s not bucketed into everyone targeting rule due to traffic allocation.",
    USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is not in experiment %s of group %s.",
    USER_NOT_BUCKETED_INTO_ANY_EXPERIMENT_IN_GROUP: "%s: User %s is not in any experiment of group %s.",
    USER_NOT_BUCKETED_INTO_TARGETING_RULE: "%s User %s not bucketed into targeting rule %s due to traffic allocation. Trying everyone rule.",
    USER_NOT_IN_FEATURE_EXPERIMENT: "%s: User %s is not in any experiment on the feature %s.",
    USER_NOT_IN_ROLLOUT: "%s: User %s is not in rollout of feature %s.",
    USER_FORCED_IN_VARIATION: "%s: User %s is forced in variation %s.",
    USER_MAPPED_TO_FORCED_VARIATION: "%s: Set variation %s for experiment %s and user %s in the forced variation map.",
    USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s does not meet conditions for targeting rule %s.",
    USER_MEETS_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s meets conditions for targeting rule %s.",
    USER_HAS_VARIATION: "%s: User %s is in variation %s of experiment %s.",
    USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED: "Variation (%s) is mapped to flag (%s), rule (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED: "Variation (%s) is mapped to flag (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID: "Invalid variation is mapped to flag (%s), rule (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID: "Invalid variation is mapped to flag (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_VARIATION: "%s: Variation %s is mapped to experiment %s and user %s in the forced variation map.",
    USER_HAS_NO_VARIATION: "%s: User %s is in no variation of experiment %s.",
    USER_HAS_NO_FORCED_VARIATION: "%s: User %s is not in the forced variation map.",
    USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT: "%s: No experiment %s mapped to user %s in the forced variation map.",
    USER_NOT_IN_ANY_EXPERIMENT: "%s: User %s is not in any experiment of group %s.",
    USER_NOT_IN_EXPERIMENT: "%s: User %s does not meet conditions to be in experiment %s.",
    USER_RECEIVED_DEFAULT_VARIABLE_VALUE: '%s: User "%s" is not in any variation or rollout rule. Returning default value for variable "%s" of feature flag "%s".',
    FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Feature "%s" is not enabled for user %s. Returning the default variable value "%s".',
    VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Variable "%s" is not used in variation "%s". Returning default value.',
    USER_RECEIVED_VARIABLE_VALUE: '%s: Got variable value "%s" for variable "%s" of feature flag "%s"',
    VALID_DATAFILE: "%s: Datafile is valid.",
    VALID_USER_PROFILE_SERVICE: "%s: Valid user profile service provided.",
    VARIATION_REMOVED_FOR_USER: "%s: Variation mapped to experiment %s has been removed for user %s.",
    VARIABLE_REQUESTED_WITH_WRONG_TYPE: '%s: Requested variable type "%s", but variable is of type "%s". Use correct API to retrieve value. Returning None.',
    VALID_BUCKETING_ID: '%s: BucketingId is valid: "%s"',
    BUCKETING_ID_NOT_STRING: "%s: BucketingID attribute is not a string. Defaulted to userId",
    EVALUATING_AUDIENCE: '%s: Starting to evaluate audience "%s" with conditions: %s.',
    EVALUATING_AUDIENCES_COMBINED: '%s: Evaluating audiences for %s "%s": %s.',
    AUDIENCE_EVALUATION_RESULT: '%s: Audience "%s" evaluated to %s.',
    AUDIENCE_EVALUATION_RESULT_COMBINED: "%s: Audiences for %s %s collectively evaluated to %s.",
    MISSING_ATTRIBUTE_VALUE: '%s: Audience condition %s evaluated to UNKNOWN because no value was passed for user attribute "%s".',
    UNEXPECTED_CONDITION_VALUE: "%s: Audience condition %s evaluated to UNKNOWN because the condition value is not supported.",
    UNEXPECTED_TYPE: '%s: Audience condition %s evaluated to UNKNOWN because a value of type "%s" was passed for user attribute "%s".',
    UNEXPECTED_TYPE_NULL: '%s: Audience condition %s evaluated to UNKNOWN because a null value was passed for user attribute "%s".',
    UNKNOWN_CONDITION_TYPE: "%s: Audience condition %s has an unknown condition type. You may need to upgrade to a newer release of the Optimizely SDK.",
    UNKNOWN_MATCH_TYPE: "%s: Audience condition %s uses an unknown match type. You may need to upgrade to a newer release of the Optimizely SDK.",
    UPDATED_OPTIMIZELY_CONFIG: "%s: Updated Optimizely config to revision %s (project id %s)",
    OUT_OF_BOUNDS: '%s: Audience condition %s evaluated to UNKNOWN because the number value for user attribute "%s" is not in the range [-2^53, +2^53].',
    UNABLE_TO_ATTACH_UNLOAD: '%s: unable to bind optimizely.close() to page unload event: "%s"'
}, v = {
    BOT_FILTERING: "$opt_bot_filtering",
    BUCKETING_ID: "$opt_bucketing_id",
    STICKY_BUCKETING_KEY: "$opt_experiment_bucket_map",
    USER_AGENT: "$opt_user_agent",
    FORCED_DECISION_NULL_RULE_KEY: "$opt_null_rule_key"
}, T = {
    AB_TEST: "ab-test",
    FEATURE: "feature",
    FEATURE_TEST: "feature-test",
    FEATURE_VARIABLE: "feature-variable",
    ALL_FEATURE_VARIABLES: "all-feature-variables",
    FLAG: "flag"
}, h = {
    FEATURE_TEST: "feature-test",
    ROLLOUT: "rollout",
    EXPERIMENT: "experiment"
}, A = {
    RULE: "rule",
    EXPERIMENT: "experiment"
}, y = {
    BOOLEAN: "boolean",
    DOUBLE: "double",
    INTEGER: "integer",
    STRING: "string",
    JSON: "json"
}, U = {
    V2: "2",
    V3: "3",
    V4: "4"
}, D = {
    SDK_NOT_READY: "Optimizely SDK not configured properly yet.",
    FLAG_KEY_INVALID: 'No flag was found for key "%s".',
    VARIABLE_VALUE_INVALID: 'Variable value for key "%s" is invalid or wrong type.'
};
!function(e) {
    e.ACTIVATE = "ACTIVATE:experiment, user_id,attributes, variation, event", e.DECISION = "DECISION:type, userId, attributes, decisionInfo", e.LOG_EVENT = "LOG_EVENT:logEvent", e.OPTIMIZELY_CONFIG_UPDATE = "OPTIMIZELY_CONFIG_UPDATE", e.TRACK = "TRACK:event_key, user_id, attributes, event_tags, event";
}(g || (g = {}));
var S = Object.freeze({
    __proto__: null,
    LOG_LEVEL: O,
    ERROR_MESSAGES: N,
    LOG_MESSAGES: R,
    CONTROL_ATTRIBUTES: v,
    JAVASCRIPT_CLIENT_ENGINE: "javascript-sdk",
    NODE_CLIENT_ENGINE: "node-sdk",
    REACT_CLIENT_ENGINE: "react-sdk",
    REACT_NATIVE_CLIENT_ENGINE: "react-native-sdk",
    REACT_NATIVE_JS_CLIENT_ENGINE: "react-native-js-sdk",
    BROWSER_CLIENT_VERSION: "4.10.0",
    NODE_CLIENT_VERSION: "4.10.0",
    DECISION_NOTIFICATION_TYPES: T,
    DECISION_SOURCES: h,
    AUDIENCE_EVALUATION_TYPES: A,
    FEATURE_VARIABLE_TYPES: y,
    DATAFILE_VERSIONS: U,
    DECISION_MESSAGES: D,
    get NOTIFICATION_TYPES () {
        return g;
    }
}), L = "CONFIG_VALIDATOR", m = [
    U.V2,
    U.V3,
    U.V4
], V = function V(e) {
    if ("object" == typeof e && null !== e) {
        var t = e, r = t.errorHandler, i = t.eventDispatcher, n = t.logger;
        if (r && "function" != typeof r.handleError) throw new Error(f(N.INVALID_ERROR_HANDLER, L));
        if (i && "function" != typeof i.dispatchEvent) throw new Error(f(N.INVALID_EVENT_DISPATCHER, L));
        if (n && "function" != typeof n.log) throw new Error(f(N.INVALID_LOGGER, L));
        return !0;
    }
    throw new Error(f(N.INVALID_CONFIG, L));
}, C = function C(e) {
    if (!e) throw new Error(f(N.NO_DATAFILE_SPECIFIED, L));
    if ("string" == typeof e) try {
        e = JSON.parse(e);
    } catch (e) {
        throw new Error(f(N.INVALID_DATAFILE_MALFORMED, L));
    }
    if ("object" == typeof e && !Array.isArray(e) && null !== e && -1 === m.indexOf(e.version)) throw new Error(f(N.INVALID_DATAFILE_VERSION, L, e.version));
    return e;
};
var F = {
    handleError: function handleError() {}
}, M = function M(e) {
    return Object.keys(e).map(function(t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
}, P = {
    dispatchEvent: function dispatchEvent(e, t) {
        var r, i = e.params, n = e.url;
        "POST" === e.httpVerb ? ((r = new XMLHttpRequest).open("POST", n, !0), r.setRequestHeader("Content-Type", "application/json"), r.onreadystatechange = function() {
            if (4 === r.readyState && t && "function" == typeof t) try {
                t({
                    statusCode: r.status
                });
            } catch (e) {}
        }, r.send(JSON.stringify(i))) : (n += "?wxhr=true", i && (n += "&" + M(i)), (r = new XMLHttpRequest).open("GET", n, !0), r.onreadystatechange = function() {
            if (4 === r.readyState && t && "function" == typeof t) try {
                t({
                    statusCode: r.status
                });
            } catch (e) {}
        }, r.send());
    }
}, b = {
    dispatchEvent: function dispatchEvent(e, t) {
        var r = e.params, i = e.url, n = new Blob([
            JSON.stringify(r)
        ], {
            type: "application/json"
        });
        t({
            statusCode: navigator.sendBeacon(i, n) ? 200 : 500
        });
    }
}, K = function() {
    function e() {}
    return e.prototype.log = function() {}, e;
}();
function x(e) {
    return new $8NKT3.ConsoleLogHandler(e);
}
var k, B, G = Object.freeze({
    __proto__: null,
    NoOpLogger: K,
    createLogger: x,
    createNoOpLogger: function createNoOpLogger() {
        return new K;
    }
});
function w(e, t, r) {
    return {
        variationKey: null,
        enabled: !1,
        variables: {},
        ruleKey: null,
        flagKey: e,
        userContext: t,
        reasons: r
    };
}
!function(e) {
    e.BOOLEAN = "boolean", e.DOUBLE = "double", e.INTEGER = "integer", e.STRING = "string", e.JSON = "json";
}(k || (k = {})), (B = exports.OptimizelyDecideOption || (exports.OptimizelyDecideOption = {})).DISABLE_DECISION_EVENT = "DISABLE_DECISION_EVENT", B.ENABLED_FLAGS_ONLY = "ENABLED_FLAGS_ONLY", B.IGNORE_USER_PROFILE_SERVICE = "IGNORE_USER_PROFILE_SERVICE", B.INCLUDE_REASONS = "INCLUDE_REASONS", B.EXCLUDE_VARIABLES = "EXCLUDE_VARIABLES";
var j = function() {
    function e(e) {
        var t, r = e.optimizely, i = e.userId, n = e.attributes;
        this.optimizely = r, this.userId = i, this.attributes = null !== (t = a({}, n)) && void 0 !== t ? t : {}, this.forcedDecisionsMap = {};
    }
    return e.prototype.setAttribute = function(e, t) {
        this.attributes[e] = t;
    }, e.prototype.getUserId = function() {
        return this.userId;
    }, e.prototype.getAttributes = function() {
        return a({}, this.attributes);
    }, e.prototype.getOptimizely = function() {
        return this.optimizely;
    }, e.prototype.decide = function(e, t) {
        return void 0 === t && (t = []), this.optimizely.decide(this.cloneUserContext(), e, t);
    }, e.prototype.decideForKeys = function(e, t) {
        return void 0 === t && (t = []), this.optimizely.decideForKeys(this.cloneUserContext(), e, t);
    }, e.prototype.decideAll = function(e) {
        return void 0 === e && (e = []), this.optimizely.decideAll(this.cloneUserContext(), e);
    }, e.prototype.trackEvent = function(e, t) {
        this.optimizely.track(e, this.userId, this.attributes, t);
    }, e.prototype.setForcedDecision = function(e, t) {
        var r, i = e.flagKey, n = null !== (r = e.ruleKey) && void 0 !== r ? r : v.FORCED_DECISION_NULL_RULE_KEY, o = {
            variationKey: t.variationKey
        };
        return this.forcedDecisionsMap[i] || (this.forcedDecisionsMap[i] = {}), this.forcedDecisionsMap[i][n] = o, !0;
    }, e.prototype.getForcedDecision = function(e) {
        return this.findForcedDecision(e);
    }, e.prototype.removeForcedDecision = function(e) {
        var t, r = null !== (t = e.ruleKey) && void 0 !== t ? t : v.FORCED_DECISION_NULL_RULE_KEY, i = e.flagKey, n = !1;
        this.forcedDecisionsMap.hasOwnProperty(i) && (this.forcedDecisionsMap[i].hasOwnProperty(r) && (delete this.forcedDecisionsMap[i][r], n = !0), 0 === Object.keys(this.forcedDecisionsMap[i]).length && delete this.forcedDecisionsMap[i]);
        return n;
    }, e.prototype.removeAllForcedDecisions = function() {
        return this.forcedDecisionsMap = {}, !0;
    }, e.prototype.findForcedDecision = function(e) {
        var t, r = null !== (t = e.ruleKey) && void 0 !== t ? t : v.FORCED_DECISION_NULL_RULE_KEY, i = e.flagKey;
        if (this.forcedDecisionsMap.hasOwnProperty(e.flagKey)) {
            var n = this.forcedDecisionsMap[i];
            if (n.hasOwnProperty(r)) return {
                variationKey: n[r].variationKey
            };
        }
        return null;
    }, e.prototype.cloneUserContext = function() {
        var t = new e({
            optimizely: this.getOptimizely(),
            userId: this.getUserId(),
            attributes: this.getAttributes()
        });
        return Object.keys(this.forcedDecisionsMap).length > 0 && (t.forcedDecisionsMap = a({}, this.forcedDecisionsMap)), t;
    }, e;
}(), Y = [
    "and",
    "or",
    "not"
];
function H(e, t) {
    if (Array.isArray(e)) {
        var r = e[0], i = e.slice(1);
        switch("string" == typeof r && -1 === Y.indexOf(r) && (r = "or", i = e), r){
            case "and":
                return function(e, t) {
                    var r = !1;
                    if (Array.isArray(e)) {
                        for(var i = 0; i < e.length; i++){
                            var n = H(e[i], t);
                            if (!1 === n) return !1;
                            null === n && (r = !0);
                        }
                        return !r || null;
                    }
                    return null;
                }(i, t);
            case "not":
                return function(e, t) {
                    if (Array.isArray(e) && e.length > 0) {
                        var r = H(e[0], t);
                        return null === r ? null : !r;
                    }
                    return null;
                }(i, t);
            default:
                return function(e, t) {
                    var r = !1;
                    if (Array.isArray(e)) {
                        for(var i = 0; i < e.length; i++){
                            var n = H(e[i], t);
                            if (!0 === n) return !0;
                            null === n && (r = !0);
                        }
                        return !!r && null;
                    }
                    return null;
                }(i, t);
        }
    }
    return t(e);
}
var X = function() {
    function e(t, r) {
        var i, n;
        this.sdkKey = null !== (i = t.sdkKey) && void 0 !== i ? i : "", this.environmentKey = null !== (n = t.environmentKey) && void 0 !== n ? n : "", this.attributes = t.attributes, this.audiences = e.getAudiences(t), this.events = t.events, this.revision = t.revision;
        var o = (t.featureFlags || []).reduce(function(e, t) {
            return e[t.id] = t.variables, e;
        }, {}), a = e.getVariableIdMap(t), s = e.getExperimentsMapById(t, o, a);
        this.experimentsMap = e.getExperimentsKeyMap(s), this.featuresMap = e.getFeaturesMap(t, o, s, a), this.datafile = r;
    }
    return e.prototype.getDatafile = function() {
        return this.datafile;
    }, e.getAudiences = function(e) {
        var t = [], r = [];
        return (e.typedAudiences || []).forEach(function(e) {
            t.push({
                id: e.id,
                conditions: JSON.stringify(e.conditions),
                name: e.name
            }), r.push(e.id);
        }), (e.audiences || []).forEach(function(e) {
            -1 === r.indexOf(e.id) && "$opt_dummy_audience" != e.id && t.push({
                id: e.id,
                conditions: JSON.stringify(e.conditions),
                name: e.name
            });
        }), t;
    }, e.getSerializedAudiences = function(t, r) {
        var i = "";
        if (t) {
            var n = "";
            t.forEach(function(t) {
                var o = "";
                if (t instanceof Array) o = "(" + (o = e.getSerializedAudiences(t, r)) + ")";
                else if (Y.indexOf(t) > -1) n = t.toUpperCase();
                else {
                    var a = r[t] ? r[t].name : t;
                    i || "NOT" === n ? (n = "" === n ? "OR" : n, i = "" === i ? n + ' "' + r[t].name + '"' : i.concat(" " + n + ' "' + a + '"')) : i = '"' + a + '"';
                }
                "" !== o && ("" !== i || "NOT" === n ? (n = "" === n ? "OR" : n, i = "" === i ? n + " " + o : i.concat(" " + n + " " + o)) : i = i.concat(o));
            });
        }
        return i;
    }, e.getExperimentAudiences = function(t, r) {
        return t.audienceConditions ? e.getSerializedAudiences(t.audienceConditions, r.audiencesById) : "";
    }, e.mergeFeatureVariables = function(e, t, r, i, n) {
        var o = (e[r] || []).reduce(function(e, t) {
            return e[t.key] = {
                id: t.id,
                key: t.key,
                type: t.type,
                value: t.defaultValue
            }, e;
        }, {});
        return (i || []).forEach(function(e) {
            var _$r = t[e.id], _$i = {
                id: e.id,
                key: _$r.key,
                type: _$r.type,
                value: n ? e.value : _$r.defaultValue
            };
            o[_$r.key] = _$i;
        }), o;
    }, e.getVariationsMap = function(t, r, i, n) {
        return t.reduce(function(t, o) {
            var a = e.mergeFeatureVariables(r, i, n, o.variables, o.featureEnabled);
            return t[o.key] = {
                id: o.id,
                key: o.key,
                featureEnabled: o.featureEnabled,
                variablesMap: a
            }, t;
        }, {});
    }, e.getVariableIdMap = function(e) {
        return (e.featureFlags || []).reduce(function(e, t) {
            return t.variables.forEach(function(t) {
                e[t.id] = t;
            }), e;
        }, {});
    }, e.getDeliveryRules = function(t, r, i, n, o) {
        return n.map(function(n) {
            return {
                id: n.id,
                key: n.key,
                audiences: e.getExperimentAudiences(n, t),
                variationsMap: e.getVariationsMap(n.variations, r, o, i)
            };
        });
    }, e.getRolloutExperimentIds = function(e) {
        var t = [];
        return (e || []).forEach(function(e) {
            e.experiments.forEach(function(e) {
                t.push(e.id);
            });
        }), t;
    }, e.getExperimentsMapById = function(t, r, i) {
        var n = this.getRolloutExperimentIds(t.rollouts);
        return (t.experiments || []).reduce(function(o, a) {
            if (-1 === n.indexOf(a.id)) {
                var s = t.experimentFeatureMap[a.id], u = "";
                s && s.length > 0 && (u = s[0]);
                var _$l = e.getVariationsMap(a.variations, r, i, u.toString());
                o[a.id] = {
                    id: a.id,
                    key: a.key,
                    audiences: e.getExperimentAudiences(a, t),
                    variationsMap: _$l
                };
            }
            return o;
        }, {});
    }, e.getExperimentsKeyMap = function(e) {
        var t = {};
        for(var r in e){
            var i = e[r];
            t[i.key] = i;
        }
        return t;
    }, e.getFeaturesMap = function(t, r, i, n) {
        var o = {};
        return t.featureFlags.forEach(function(a) {
            var s = {}, u = [];
            a.experimentIds.forEach(function(e) {
                var _$t = i[e];
                _$t && (s[_$t.key] = _$t), u.push(i[e]);
            });
            var _$l = (a.variables || []).reduce(function(e, t) {
                return e[t.key] = {
                    id: t.id,
                    key: t.key,
                    type: t.type,
                    value: t.defaultValue
                }, e;
            }, {}), _$E = [], _$I = t.rolloutIdMap[a.rolloutId];
            _$I && (_$E = e.getDeliveryRules(t, r, a.id, _$I.experiments, n)), o[a.key] = {
                id: a.id,
                key: a.key,
                experimentRules: u,
                deliveryRules: _$E,
                experimentsMap: s,
                variablesMap: _$l
            };
        }), o;
    }, e;
}();
var z = "PROJECT_CONFIG";
var J = function J(e, t) {
    void 0 === t && (t = null);
    var r, i, n, o, a = ((o = l({}, r = e)).audiences = (r.audiences || []).map(function(e) {
        return l({}, e);
    }), o.experiments = (r.experiments || []).map(function(e) {
        return l({}, e);
    }), o.featureFlags = (r.featureFlags || []).map(function(e) {
        return l({}, e);
    }), o.groups = (r.groups || []).map(function(e) {
        var _$t = l({}, e);
        return _$t.experiments = (e.experiments || []).map(function(e) {
            return l({}, e);
        }), _$t;
    }), o.rollouts = (r.rollouts || []).map(function(e) {
        var _$t = l({}, e);
        return _$t.experiments = (e.experiments || []).map(function(e) {
            return l({}, e);
        }), _$t;
    }), o.environmentKey = null !== (i = r.environmentKey) && void 0 !== i ? i : "", o.sdkKey = null !== (n = r.sdkKey) && void 0 !== n ? n : "", o);
    return a.__datafileStr = null === t ? JSON.stringify(e) : t, (a.audiences || []).forEach(function(e) {
        e.conditions = JSON.parse(e.conditions);
    }), a.audiencesById = E(a.audiences, "id"), l(a.audiencesById, E(a.typedAudiences, "id")), a.attributeKeyMap = E(a.attributes, "key"), a.eventKeyMap = E(a.events, "key"), a.groupIdMap = E(a.groups, "id"), Object.keys(a.groupIdMap || {}).forEach(function(e) {
        (a.groupIdMap[e].experiments || []).forEach(function(t) {
            a.experiments.push(l(t, {
                groupId: e
            }));
        });
    }), a.rolloutIdMap = E(a.rollouts || [], "id"), I(a.rolloutIdMap || {}).forEach(function(e) {
        (e.experiments || []).forEach(function(e) {
            a.experiments.push(e), e.variationKeyMap = E(e.variations, "key");
        });
    }), a.experimentKeyMap = E(a.experiments, "key"), a.experimentIdMap = E(a.experiments, "id"), a.variationIdMap = {}, a.variationVariableUsageMap = {}, (a.experiments || []).forEach(function(e) {
        e.variationKeyMap = E(e.variations, "key"), l(a.variationIdMap, E(e.variations, "id")), I(e.variationKeyMap || {}).forEach(function(e) {
            e.variables && (a.variationVariableUsageMap[e.id] = E(e.variables, "id"));
        });
    }), a.experimentFeatureMap = {}, a.featureKeyMap = E(a.featureFlags || [], "key"), I(a.featureKeyMap || {}).forEach(function(e) {
        e.variables.forEach(function(e) {
            e.type === y.STRING && e.subType === y.JSON && (e.type = y.JSON, delete e.subType);
        }), e.variableKeyMap = E(e.variables, "key"), (e.experimentIds || []).forEach(function(t) {
            a.experimentFeatureMap[t] ? a.experimentFeatureMap[t].push(e.id) : a.experimentFeatureMap[t] = [
                e.id
            ];
        });
    }), a.flagRulesMap = {}, (a.featureFlags || []).forEach(function(e) {
        var _$t = [];
        e.experimentIds.forEach(function(e) {
            var r = a.experimentIdMap[e];
            r && _$t.push(r);
        });
        var r = a.rolloutIdMap[e.rolloutId];
        r && _$t.push.apply(_$t, r.experiments), a.flagRulesMap[e.key] = _$t;
    }), a.flagVariationsMap = {}, c(a.flagRulesMap || {}).forEach(function(e) {
        var _$t = e[0], r = e[1], i = [];
        r.forEach(function(e) {
            e.variations.forEach(function(e) {
                _(i, function(t) {
                    return t.id === e.id;
                }) || i.push(e);
            });
        }), a.flagVariationsMap[_$t] = i;
    }), a;
}, Z = function Z(e, t) {
    var r = e.experimentIdMap[t];
    if (!r) throw new Error(f(N.INVALID_EXPERIMENT_ID, z, t));
    return r.layerId;
}, W = function W(e, t, r) {
    var i = e.attributeKeyMap[t], n = 0 === t.indexOf("$opt_");
    return i ? (n && r.log(O.WARNING, "Attribute %s unexpectedly has reserved prefix %s; using attribute ID instead of reserved attribute name.", t, "$opt_"), i.id) : n ? t : (r.log(O.DEBUG, N.UNRECOGNIZED_ATTRIBUTE, z, t), null);
}, q = function q(e, t) {
    var r = e.eventKeyMap[t];
    return r ? r.id : null;
}, $ = function $(e, t) {
    var r = e.experimentKeyMap[t];
    if (!r) throw new Error(f(N.INVALID_EXPERIMENT_KEY, z, t));
    return r.status;
}, Q = function Q(e, t) {
    return e.variationIdMap.hasOwnProperty(t) ? e.variationIdMap[t].key : null;
}, ee = function ee(e, t) {
    if (e.experimentKeyMap.hasOwnProperty(t)) {
        var r = e.experimentKeyMap[t];
        if (r) return r;
    }
    throw new Error(f(N.EXPERIMENT_KEY_NOT_IN_DATAFILE, z, t));
}, te = function te(e, t) {
    var r = e.experimentIdMap[t];
    if (!r) throw new Error(f(N.INVALID_EXPERIMENT_ID, z, t));
    return r.trafficAllocation;
}, re = function re(e, t, r) {
    if (e.experimentIdMap.hasOwnProperty(t)) {
        var i = e.experimentIdMap[t];
        if (i) return i;
    }
    return r.log(O.ERROR, N.INVALID_EXPERIMENT_ID, z, t), null;
}, ie = function ie(e, t, r) {
    if (!e) return null;
    var i = _(e.flagVariationsMap[t], function(e) {
        return e.key === r;
    });
    return i || null;
}, ne = function ne(e, t, r) {
    if (e.featureKeyMap.hasOwnProperty(t)) {
        var i = e.featureKeyMap[t];
        if (i) return i;
    }
    return r.log(O.ERROR, N.FEATURE_NOT_IN_DATAFILE, z, t), null;
}, oe = function oe(e) {
    return e.__datafileStr;
}, ae = function ae(e) {
    var t;
    try {
        t = C(e.datafile);
    } catch (e) {
        return {
            configObj: null,
            error: e
        };
    }
    if (e.jsonSchemaValidator) try {
        e.jsonSchemaValidator.validate(t), e.logger.log(O.INFO, R.VALID_DATAFILE, z);
    } catch (e) {
        return {
            configObj: null,
            error: e
        };
    }
    else e.logger.log(O.INFO, R.SKIPPING_JSON_VALIDATION, z);
    var r = [
        t
    ];
    return "string" == typeof e.datafile && r.push(e.datafile), {
        configObj: J.apply(void 0, r),
        error: null
    };
}, se = function se(e) {
    return !!e.sendFlagDecisions;
}, ue = $8NKT3.getLogger();
function le(e, t) {
    return e instanceof Error ? e.message : t || "Unknown error";
}
var Ee = function() {
    function e(e) {
        this.updateListeners = [], this.configObj = null, this.optimizelyConfigObj = null, this.datafileManager = null;
        try {
            if (this.jsonSchemaValidator = e.jsonSchemaValidator, !e.datafile && !e.sdkKey) {
                var t = new Error(f(N.DATAFILE_AND_SDK_KEY_MISSING, "PROJECT_CONFIG_MANAGER"));
                return this.readyPromise = Promise.resolve({
                    success: !1,
                    reason: le(t)
                }), void ue.error(t);
            }
            var r = null;
            e.datafile && (r = this.handleNewDatafile(e.datafile)), e.sdkKey && e.datafileManager ? (this.datafileManager = e.datafileManager, this.datafileManager.start(), this.readyPromise = this.datafileManager.onReady().then(this.onDatafileManagerReadyFulfill.bind(this), this.onDatafileManagerReadyReject.bind(this)), this.datafileManager.on("update", this.onDatafileManagerUpdate.bind(this))) : this.configObj ? this.readyPromise = Promise.resolve({
                success: !0
            }) : this.readyPromise = Promise.resolve({
                success: !1,
                reason: le(r, "Invalid datafile")
            });
        } catch (e) {
            ue.error(e), this.readyPromise = Promise.resolve({
                success: !1,
                reason: le(e, "Error in initialize")
            });
        }
    }
    return e.prototype.onDatafileManagerReadyFulfill = function() {
        if (this.datafileManager) {
            var _$e = this.handleNewDatafile(this.datafileManager.get());
            return _$e ? {
                success: !1,
                reason: le(_$e)
            } : {
                success: !0
            };
        }
        return {
            success: !1,
            reason: le(null, "Datafile manager is not provided")
        };
    }, e.prototype.onDatafileManagerReadyReject = function(e) {
        return {
            success: !1,
            reason: le(e, "Failed to become ready")
        };
    }, e.prototype.onDatafileManagerUpdate = function() {
        this.datafileManager && this.handleNewDatafile(this.datafileManager.get());
    }, e.prototype.handleNewDatafile = function(e) {
        var t = ae({
            datafile: e,
            jsonSchemaValidator: this.jsonSchemaValidator,
            logger: ue
        }), r = t.configObj, i = t.error;
        if (i) ue.error(i);
        else {
            var n = this.configObj ? this.configObj.revision : "null";
            r && n !== r.revision && (this.configObj = r, this.optimizelyConfigObj = null, this.updateListeners.forEach(function(e) {
                return e(r);
            }));
        }
        return i;
    }, e.prototype.getConfig = function() {
        return this.configObj;
    }, e.prototype.getOptimizelyConfig = function() {
        var _$e, t;
        return !this.optimizelyConfigObj && this.configObj && (this.optimizelyConfigObj = (_$e = this.configObj, t = oe(this.configObj), new X(_$e, t))), this.optimizelyConfigObj;
    }, e.prototype.onReady = function() {
        return this.readyPromise;
    }, e.prototype.onUpdate = function(e) {
        var t = this;
        return this.updateListeners.push(e), function() {
            var r = t.updateListeners.indexOf(e);
            r > -1 && t.updateListeners.splice(r, 1);
        };
    }, e.prototype.stop = function() {
        this.datafileManager && this.datafileManager.stop(), this.updateListeners = [];
    }, e;
}();
var Ie = Math.pow(2, 32), ce = function ce(e) {
    var t = [], r = e.experimentIdMap[e.experimentId].groupId;
    if (r) {
        var i = e.groupIdMap[r];
        if (!i) throw new Error(f(N.INVALID_GROUP_ID, "BUCKETER", r));
        if ("random" === i.policy) {
            var n = _e(i, e.bucketingId, e.userId, e.logger);
            if (null === n) return e.logger.log(O.INFO, R.USER_NOT_IN_ANY_EXPERIMENT, "BUCKETER", e.userId, r), t.push([
                R.USER_NOT_IN_ANY_EXPERIMENT,
                "BUCKETER",
                e.userId,
                r
            ]), {
                result: null,
                reasons: t
            };
            if (n !== e.experimentId) return e.logger.log(O.INFO, R.USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r), t.push([
                R.USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP,
                "BUCKETER",
                e.userId,
                e.experimentKey,
                r
            ]), {
                result: null,
                reasons: t
            };
            e.logger.log(O.INFO, R.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r), t.push([
                R.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP,
                "BUCKETER",
                e.userId,
                e.experimentKey,
                r
            ]);
        }
    }
    var o = "" + e.bucketingId + e.experimentId, a = fe(o);
    e.logger.log(O.DEBUG, R.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", a, e.userId), t.push([
        R.USER_ASSIGNED_TO_EXPERIMENT_BUCKET,
        "BUCKETER",
        a,
        e.userId
    ]);
    var s = de(a, e.trafficAllocationConfig);
    return null === s || e.variationIdMap[s] ? {
        result: s,
        reasons: t
    } : (s && (e.logger.log(O.WARNING, R.INVALID_VARIATION_ID, "BUCKETER"), t.push([
        R.INVALID_VARIATION_ID,
        "BUCKETER"
    ])), {
        result: null,
        reasons: t
    });
}, _e = function _e(e, t, r, i) {
    var n = "" + t + e.id, o = fe(n);
    i.log(O.DEBUG, R.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", o, r);
    var a = e.trafficAllocation;
    return de(o, a);
}, de = function de(e, t) {
    for(var r = 0; r < t.length; r++)if (e < t[r].endOfRange) return t[r].entityId;
    return null;
}, fe = function fe(e) {
    try {
        var _$t = n.v3(e, 1) / Ie;
        return Math.floor(1e4 * _$t);
    } catch (t) {
        throw new Error(f(N.INVALID_BUCKETING_ID, "BUCKETER", e, t.message));
    }
}, ge = $8NKT3.getLogger();
function pe(e) {
    return /^\d+$/.test(e);
}
function Oe(e) {
    var t = e.indexOf("-"), r = e.indexOf("+");
    return !(t < 0) && (r < 0 || t < r);
}
function Ne(e) {
    var t = e.indexOf("-"), r = e.indexOf("+");
    return !(r < 0) && (t < 0 || r < t);
}
function Re(e) {
    var t = e, r = "";
    if (function(e) {
        return /\s/.test(e);
    }(e)) return ge.warn(R.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
    if (Oe(e) ? (t = e.substring(0, e.indexOf("-")), r = e.substring(e.indexOf("-") + 1)) : Ne(e) && (t = e.substring(0, e.indexOf("+")), r = e.substring(e.indexOf("+") + 1)), "string" != typeof t || "string" != typeof r) return null;
    var i = t.split(".").length - 1;
    if (i > 2) return ge.warn(R.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
    var n = t.split(".");
    if (n.length != i + 1) return ge.warn(R.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
    for(var o = 0, a = n; o < a.length; o++){
        if (!pe(a[o])) return ge.warn(R.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
    }
    return r && n.push(r), n;
}
var ve = "CUSTOM_ATTRIBUTE_CONDITION_EVALUATOR", Te = $8NKT3.getLogger(), he = [
    "exact",
    "exists",
    "gt",
    "ge",
    "lt",
    "le",
    "substring",
    "semver_eq",
    "semver_lt",
    "semver_le",
    "semver_gt",
    "semver_ge"
], Ae = {};
function ye(e) {
    return "string" == typeof e || "boolean" == typeof e || p.isNumber(e);
}
function Ue(e, t) {
    var r = e.value, i = typeof r === "undefined" ? "undefined" : (0, $aRmx5._)(r), n = e.name, o = t[n], a = typeof o === "undefined" ? "undefined" : (0, $aRmx5._)(o);
    return !ye(r) || p.isNumber(r) && !p.isSafeInteger(r) ? (Te.warn(R.UNEXPECTED_CONDITION_VALUE, ve, JSON.stringify(e)), null) : null === o ? (Te.debug(R.UNEXPECTED_TYPE_NULL, ve, JSON.stringify(e), n), null) : ye(o) && i === a ? p.isNumber(o) && !p.isSafeInteger(o) ? (Te.warn(R.OUT_OF_BOUNDS, ve, JSON.stringify(e), n), null) : r === o : (Te.warn(R.UNEXPECTED_TYPE, ve, JSON.stringify(e), a, n), null);
}
function De(e, t) {
    var r = e.name, i = t[r], n = typeof i === "undefined" ? "undefined" : (0, $aRmx5._)(i), o = e.value;
    return null !== o && p.isSafeInteger(o) ? null === i ? (Te.debug(R.UNEXPECTED_TYPE_NULL, ve, JSON.stringify(e), r), !1) : p.isNumber(i) ? !!p.isSafeInteger(i) || (Te.warn(R.OUT_OF_BOUNDS, ve, JSON.stringify(e), r), !1) : (Te.warn(R.UNEXPECTED_TYPE, ve, JSON.stringify(e), n, r), !1) : (Te.warn(R.UNEXPECTED_CONDITION_VALUE, ve, JSON.stringify(e)), !1);
}
function Se(e, t) {
    var r = e.name, i = t[r], n = typeof i === "undefined" ? "undefined" : (0, $aRmx5._)(i), o = e.value;
    return "string" != typeof o ? (Te.warn(R.UNEXPECTED_CONDITION_VALUE, ve, JSON.stringify(e)), null) : null === i ? (Te.debug(R.UNEXPECTED_TYPE_NULL, ve, JSON.stringify(e), r), null) : "string" != typeof i ? (Te.warn(R.UNEXPECTED_TYPE, ve, JSON.stringify(e), n, r), null) : function(e, t) {
        var r = Re(t), i = Re(e);
        if (!r || !i) return null;
        for(var n = r.length, o = 0; o < i.length; o++){
            if (n <= o) return Oe(e) || Ne(e) ? 1 : -1;
            if (pe(r[o])) {
                var a = parseInt(r[o]), s = parseInt(i[o]);
                if (a > s) return 1;
                if (a < s) return -1;
            } else {
                if (r[o] < i[o]) return Oe(e) && !Oe(t) ? 1 : -1;
                if (r[o] > i[o]) return !Oe(e) && Oe(t) ? -1 : 1;
            }
        }
        return Oe(t) && !Oe(e) ? -1 : 0;
    }(o, i);
}
Ae.exact = Ue, Ae.exists = function(e, t) {
    var r = t[e.name];
    return null != r;
}, Ae.gt = function(e, t) {
    var r = t[e.name], i = e.value;
    if (!De(e, t) || null === i) return null;
    return r > i;
}, Ae.ge = function(e, t) {
    var r = t[e.name], i = e.value;
    if (!De(e, t) || null === i) return null;
    return r >= i;
}, Ae.lt = function(e, t) {
    var r = t[e.name], i = e.value;
    if (!De(e, t) || null === i) return null;
    return r < i;
}, Ae.le = function(e, t) {
    var r = t[e.name], i = e.value;
    if (!De(e, t) || null === i) return null;
    return r <= i;
}, Ae.substring = function(e, t) {
    var r = e.name, i = t[e.name], n = typeof i === "undefined" ? "undefined" : (0, $aRmx5._)(i), o = e.value;
    if ("string" != typeof o) return Te.warn(R.UNEXPECTED_CONDITION_VALUE, ve, JSON.stringify(e)), null;
    if (null === i) return Te.debug(R.UNEXPECTED_TYPE_NULL, ve, JSON.stringify(e), r), null;
    if ("string" != typeof i) return Te.warn(R.UNEXPECTED_TYPE, ve, JSON.stringify(e), n, r), null;
    return -1 !== i.indexOf(o);
}, Ae.semver_eq = function(e, t) {
    var r = Se(e, t);
    if (null === r) return null;
    return 0 === r;
}, Ae.semver_gt = function(e, t) {
    var r = Se(e, t);
    if (null === r) return null;
    return r > 0;
}, Ae.semver_ge = function(e, t) {
    var r = Se(e, t);
    if (null === r) return null;
    return r >= 0;
}, Ae.semver_lt = function(e, t) {
    var r = Se(e, t);
    if (null === r) return null;
    return r < 0;
}, Ae.semver_le = function(e, t) {
    var r = Se(e, t);
    if (null === r) return null;
    return r <= 0;
};
var Le = Object.freeze({
    __proto__: null,
    evaluate: function evaluate(e, t) {
        var r = e.match;
        if (void 0 !== r && -1 === he.indexOf(r)) return Te.warn(R.UNKNOWN_MATCH_TYPE, ve, JSON.stringify(e)), null;
        var i = e.name;
        return t.hasOwnProperty(i) || "exists" == r ? (r && Ae[r] || Ue)(e, t) : (Te.debug(R.MISSING_ATTRIBUTE_VALUE, ve, JSON.stringify(e), i), null);
    }
}), me = $8NKT3.getLogger(), Ve = function() {
    function e(e) {
        this.typeToEvaluatorMap = p.assign({}, e, {
            custom_attribute: Le
        });
    }
    return e.prototype.evaluate = function(e, t, r) {
        var i = this;
        if (void 0 === r && (r = {}), !e || 0 === e.length) return !0;
        return !!H(e, function(e) {
            var n = t[e];
            if (n) {
                me.log(O.DEBUG, R.EVALUATING_AUDIENCE, "AUDIENCE_EVALUATOR", e, JSON.stringify(n.conditions));
                var o = H(n.conditions, i.evaluateConditionWithUserAttributes.bind(i, r)), a = null === o ? "UNKNOWN" : o.toString().toUpperCase();
                return me.log(O.DEBUG, R.AUDIENCE_EVALUATION_RESULT, "AUDIENCE_EVALUATOR", e, a), o;
            }
            return null;
        });
    }, e.prototype.evaluateConditionWithUserAttributes = function(e, t) {
        var r = this.typeToEvaluatorMap[t.type];
        if (!r) return me.log(O.WARNING, R.UNKNOWN_CONDITION_TYPE, "AUDIENCE_EVALUATOR", JSON.stringify(t)), null;
        try {
            return r.evaluate(t, e);
        } catch (e) {
            me.log(O.ERROR, N.CONDITION_EVALUATOR_ERROR, "AUDIENCE_EVALUATOR", t.type, e.message);
        }
        return null;
    }, e;
}();
function Ce(e) {
    return "string" == typeof e && "" !== e;
}
var Fe = "DECISION_SERVICE", Me = function() {
    function e(e) {
        var t;
        this.audienceEvaluator = (t = e.UNSTABLE_conditionEvaluators, new Ve(t)), this.forcedVariationMap = {}, this.logger = e.logger, this.userProfileService = e.userProfileService || null;
    }
    return e.prototype.getVariation = function(e, t, r, i) {
        void 0 === i && (i = {});
        var n = r.getUserId(), o = r.getAttributes(), a = this.getBucketingId(n, o), s = [], u = t.key;
        if (!this.checkIfExperimentIsActive(e, u)) return this.logger.log(O.INFO, R.EXPERIMENT_NOT_RUNNING, Fe, u), s.push([
            R.EXPERIMENT_NOT_RUNNING,
            Fe,
            u
        ]), {
            result: null,
            reasons: s
        };
        var _$l = this.getForcedVariation(e, u, n);
        s.push.apply(s, _$l.reasons);
        var _$E = _$l.result;
        if (_$E) return {
            result: _$E,
            reasons: s
        };
        var _$I = this.getWhitelistedVariation(t, n);
        s.push.apply(s, _$I.reasons);
        var _$c = _$I.result;
        if (_$c) return {
            result: _$c.key,
            reasons: s
        };
        var _$_ = i[exports.OptimizelyDecideOption.IGNORE_USER_PROFILE_SERVICE], _$d = this.resolveExperimentBucketMap(n, o);
        if (!_$_ && (_$c = this.getStoredVariation(e, t, n, _$d))) return this.logger.log(O.INFO, R.RETURNING_STORED_VARIATION, Fe, _$c.key, u, n), s.push([
            R.RETURNING_STORED_VARIATION,
            Fe,
            _$c.key,
            u,
            n
        ]), {
            result: _$c.key,
            reasons: s
        };
        var _$f = this.checkIfUserIsInAudience(e, t, A.EXPERIMENT, o, "");
        if (s.push.apply(s, _$f.reasons), !_$f.result) return this.logger.log(O.INFO, R.USER_NOT_IN_EXPERIMENT, Fe, n, u), s.push([
            R.USER_NOT_IN_EXPERIMENT,
            Fe,
            n,
            u
        ]), {
            result: null,
            reasons: s
        };
        var g = this.buildBucketerParams(e, t, a, n), p = ce(g);
        s.push.apply(s, p.reasons);
        var N = p.result;
        return N && (_$c = e.variationIdMap[N]), _$c ? (this.logger.log(O.INFO, R.USER_HAS_VARIATION, Fe, n, _$c.key, u), s.push([
            R.USER_HAS_VARIATION,
            Fe,
            n,
            _$c.key,
            u
        ]), _$_ || this.saveUserProfile(t, _$c, n, _$d), {
            result: _$c.key,
            reasons: s
        }) : (this.logger.log(O.DEBUG, R.USER_HAS_NO_VARIATION, Fe, n, u), s.push([
            R.USER_HAS_NO_VARIATION,
            Fe,
            n,
            u
        ]), {
            result: null,
            reasons: s
        });
    }, e.prototype.resolveExperimentBucketMap = function(e, t) {
        t = t || {};
        var r = this.getUserProfile(e) || {}, i = t[v.STICKY_BUCKETING_KEY];
        return p.assign({}, r.experiment_bucket_map, i);
    }, e.prototype.checkIfExperimentIsActive = function(e, t) {
        return function(e, t) {
            return "Running" === $(e, t);
        }(e, t);
    }, e.prototype.getWhitelistedVariation = function(e, t) {
        var r = [];
        if (e.forcedVariations && e.forcedVariations.hasOwnProperty(t)) {
            var i = e.forcedVariations[t];
            return e.variationKeyMap.hasOwnProperty(i) ? (this.logger.log(O.INFO, R.USER_FORCED_IN_VARIATION, Fe, t, i), r.push([
                R.USER_FORCED_IN_VARIATION,
                Fe,
                t,
                i
            ]), {
                result: e.variationKeyMap[i],
                reasons: r
            }) : (this.logger.log(O.ERROR, R.FORCED_BUCKETING_FAILED, Fe, i, t), r.push([
                R.FORCED_BUCKETING_FAILED,
                Fe,
                i,
                t
            ]), {
                result: null,
                reasons: r
            });
        }
        return {
            result: null,
            reasons: r
        };
    }, e.prototype.checkIfUserIsInAudience = function(e, t, r, i, n) {
        var o = [], a = function(e, t) {
            var _$r = e.experimentIdMap[t];
            if (!_$r) throw new Error(f(N.INVALID_EXPERIMENT_ID, z, t));
            return _$r.audienceConditions || _$r.audienceIds;
        }(e, t.id), s = e.audiencesById;
        this.logger.log(O.DEBUG, R.EVALUATING_AUDIENCES_COMBINED, Fe, r, n || t.key, JSON.stringify(a)), o.push([
            R.EVALUATING_AUDIENCES_COMBINED,
            Fe,
            r,
            n || t.key,
            JSON.stringify(a)
        ]);
        var u = this.audienceEvaluator.evaluate(a, s, i);
        return this.logger.log(O.INFO, R.AUDIENCE_EVALUATION_RESULT_COMBINED, Fe, r, n || t.key, u.toString().toUpperCase()), o.push([
            R.AUDIENCE_EVALUATION_RESULT_COMBINED,
            Fe,
            r,
            n || t.key,
            u.toString().toUpperCase()
        ]), {
            result: u,
            reasons: o
        };
    }, e.prototype.buildBucketerParams = function(e, t, r, i) {
        return {
            bucketingId: r,
            experimentId: t.id,
            experimentKey: t.key,
            experimentIdMap: e.experimentIdMap,
            experimentKeyMap: e.experimentKeyMap,
            groupIdMap: e.groupIdMap,
            logger: this.logger,
            trafficAllocationConfig: te(e, t.id),
            userId: i,
            variationIdMap: e.variationIdMap
        };
    }, e.prototype.getStoredVariation = function(e, t, r, i) {
        if (i.hasOwnProperty(t.id)) {
            var n = i[t.id], o = n.variation_id;
            if (e.variationIdMap.hasOwnProperty(o)) return e.variationIdMap[n.variation_id];
            this.logger.log(O.INFO, R.SAVED_VARIATION_NOT_FOUND, Fe, r, o, t.key);
        }
        return null;
    }, e.prototype.getUserProfile = function(e) {
        var _$t = {
            user_id: e,
            experiment_bucket_map: {}
        };
        if (!this.userProfileService) return _$t;
        try {
            return this.userProfileService.lookup(e);
        } catch (t) {
            this.logger.log(O.ERROR, N.USER_PROFILE_LOOKUP_ERROR, Fe, e, t.message);
        }
        return null;
    }, e.prototype.saveUserProfile = function(e, t, r, i) {
        if (this.userProfileService) try {
            i[e.id] = {
                variation_id: t.id
            }, this.userProfileService.save({
                user_id: r,
                experiment_bucket_map: i
            }), this.logger.log(O.INFO, R.SAVED_VARIATION, Fe, t.key, e.key, r);
        } catch (e) {
            this.logger.log(O.ERROR, N.USER_PROFILE_SAVE_ERROR, Fe, r, e.message);
        }
    }, e.prototype.getVariationForFeature = function(e, t, r, i) {
        void 0 === i && (i = {});
        var n = [], o = this.getVariationForFeatureExperiment(e, t, r, i);
        n.push.apply(n, o.reasons);
        var a = o.result;
        if (null !== a.variation) return {
            result: a,
            reasons: n
        };
        var s = this.getVariationForRollout(e, t, r);
        n.push.apply(n, s.reasons);
        var u = s.result, _$l = r.getUserId();
        return u.variation ? (this.logger.log(O.DEBUG, R.USER_IN_ROLLOUT, Fe, _$l, t.key), n.push([
            R.USER_IN_ROLLOUT,
            Fe,
            _$l,
            t.key
        ]), {
            result: u,
            reasons: n
        }) : (this.logger.log(O.DEBUG, R.USER_NOT_IN_ROLLOUT, Fe, _$l, t.key), n.push([
            R.USER_NOT_IN_ROLLOUT,
            Fe,
            _$l,
            t.key
        ]), {
            result: u,
            reasons: n
        });
    }, e.prototype.getVariationForFeatureExperiment = function(e, t, r, i) {
        void 0 === i && (i = {});
        var n, o, a = [], s = null;
        if (t.experimentIds.length > 0) for(o = 0; o < t.experimentIds.length; o++){
            var u = re(e, t.experimentIds[o], this.logger);
            if (u && (n = this.getVariationFromExperimentRule(e, t.key, u, r, i), a.push.apply(a, n.reasons), s = n.result)) {
                var _$l = null;
                return (_$l = u.variationKeyMap[s]) || (_$l = ie(e, t.key, s)), {
                    result: {
                        experiment: u,
                        variation: _$l,
                        decisionSource: h.FEATURE_TEST
                    },
                    reasons: a
                };
            }
        }
        else this.logger.log(O.DEBUG, R.FEATURE_HAS_NO_EXPERIMENTS, Fe, t.key), a.push([
            R.FEATURE_HAS_NO_EXPERIMENTS,
            Fe,
            t.key
        ]);
        return {
            result: {
                experiment: null,
                variation: null,
                decisionSource: h.FEATURE_TEST
            },
            reasons: a
        };
    }, e.prototype.getVariationForRollout = function(e, t, r) {
        var i = [];
        if (!t.rolloutId) return this.logger.log(O.DEBUG, R.NO_ROLLOUT_EXISTS, Fe, t.key), i.push([
            R.NO_ROLLOUT_EXISTS,
            Fe,
            t.key
        ]), {
            result: {
                experiment: null,
                variation: null,
                decisionSource: h.ROLLOUT
            },
            reasons: i
        };
        var n = e.rolloutIdMap[t.rolloutId];
        if (!n) return this.logger.log(O.ERROR, N.INVALID_ROLLOUT_ID, Fe, t.rolloutId, t.key), i.push([
            N.INVALID_ROLLOUT_ID,
            Fe,
            t.rolloutId,
            t.key
        ]), {
            result: {
                experiment: null,
                variation: null,
                decisionSource: h.ROLLOUT
            },
            reasons: i
        };
        var o, a, s, u = n.experiments;
        if (0 === u.length) return this.logger.log(O.ERROR, R.ROLLOUT_HAS_NO_EXPERIMENTS, Fe, t.rolloutId), i.push([
            R.ROLLOUT_HAS_NO_EXPERIMENTS,
            Fe,
            t.rolloutId
        ]), {
            result: {
                experiment: null,
                variation: null,
                decisionSource: h.ROLLOUT
            },
            reasons: i
        };
        for(var _$l = 0; _$l < u.length;){
            if (o = this.getVariationFromDeliveryRule(e, t.key, u, _$l, r), i.push.apply(i, o.reasons), s = o.result, a = o.skipToEveryoneElse, s) return {
                result: {
                    experiment: e.experimentIdMap[u[_$l].id],
                    variation: s,
                    decisionSource: h.ROLLOUT
                },
                reasons: i
            };
            _$l = a ? u.length - 1 : _$l + 1;
        }
        return {
            result: {
                experiment: null,
                variation: null,
                decisionSource: h.ROLLOUT
            },
            reasons: i
        };
    }, e.prototype.getBucketingId = function(e, t) {
        var r = e;
        return null != t && "object" == typeof t && t.hasOwnProperty(v.BUCKETING_ID) && ("string" == typeof t[v.BUCKETING_ID] ? (r = t[v.BUCKETING_ID], this.logger.log(O.DEBUG, R.VALID_BUCKETING_ID, Fe, r)) : this.logger.log(O.WARNING, R.BUCKETING_ID_NOT_STRING, Fe)), r;
    }, e.prototype.findValidatedForcedDecision = function(e, t, r, i) {
        var n, o = [], a = t.getForcedDecision({
            flagKey: r,
            ruleKey: i
        }), s = null, u = t.getUserId();
        return e && a && (n = a.variationKey, (s = ie(e, r, n)) ? i ? (this.logger.log(O.INFO, R.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED, n, r, i, u), o.push([
            R.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED,
            n,
            r,
            i,
            u
        ])) : (this.logger.log(O.INFO, R.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED, n, r, u), o.push([
            R.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED,
            n,
            r,
            u
        ])) : i ? (this.logger.log(O.INFO, R.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID, r, i, u), o.push([
            R.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID,
            r,
            i,
            u
        ])) : (this.logger.log(O.INFO, R.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID, r, u), o.push([
            R.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID,
            r,
            u
        ]))), {
            result: s,
            reasons: o
        };
    }, e.prototype.removeForcedVariation = function(e, t, r) {
        if (!e) throw new Error(f(N.INVALID_USER_ID, Fe));
        if (!this.forcedVariationMap.hasOwnProperty(e)) throw new Error(f(N.USER_NOT_IN_FORCED_VARIATION, Fe, e));
        delete this.forcedVariationMap[e][t], this.logger.log(O.DEBUG, R.VARIATION_REMOVED_FOR_USER, Fe, r, e);
    }, e.prototype.setInForcedVariationMap = function(e, t, r) {
        this.forcedVariationMap.hasOwnProperty(e) || (this.forcedVariationMap[e] = {}), this.forcedVariationMap[e][t] = r, this.logger.log(O.DEBUG, R.USER_MAPPED_TO_FORCED_VARIATION, Fe, r, t, e);
    }, e.prototype.getForcedVariation = function(e, t, r) {
        var i, n = [], o = this.forcedVariationMap[r];
        if (!o) return this.logger.log(O.DEBUG, R.USER_HAS_NO_FORCED_VARIATION, Fe, r), {
            result: null,
            reasons: n
        };
        try {
            var a = ee(e, t);
            if (!a.hasOwnProperty("id")) return this.logger.log(O.ERROR, N.IMPROPERLY_FORMATTED_EXPERIMENT, Fe, t), n.push([
                N.IMPROPERLY_FORMATTED_EXPERIMENT,
                Fe,
                t
            ]), {
                result: null,
                reasons: n
            };
            i = a.id;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), n.push(e.message), {
                result: null,
                reasons: n
            };
        }
        var s = o[i];
        if (!s) return this.logger.log(O.DEBUG, R.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, Fe, t, r), {
            result: null,
            reasons: n
        };
        var u = Q(e, s);
        return u ? (this.logger.log(O.DEBUG, R.USER_HAS_FORCED_VARIATION, Fe, u, t, r), n.push([
            R.USER_HAS_FORCED_VARIATION,
            Fe,
            u,
            t,
            r
        ])) : this.logger.log(O.DEBUG, R.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, Fe, t, r), {
            result: u,
            reasons: n
        };
    }, e.prototype.setForcedVariation = function(e, t, r, i) {
        if (null != i && !Ce(i)) return this.logger.log(O.ERROR, N.INVALID_VARIATION_KEY, Fe), !1;
        var n;
        try {
            var o = ee(e, t);
            if (!o.hasOwnProperty("id")) return this.logger.log(O.ERROR, N.IMPROPERLY_FORMATTED_EXPERIMENT, Fe, t), !1;
            n = o.id;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), !1;
        }
        if (null == i) try {
            return this.removeForcedVariation(r, n, t), !0;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), !1;
        }
        var a = function(e, t, r) {
            var _$i = e.experimentKeyMap[t];
            return _$i.variationKeyMap.hasOwnProperty(r) ? _$i.variationKeyMap[r].id : null;
        }(e, t, i);
        if (!a) return this.logger.log(O.ERROR, N.NO_VARIATION_FOR_EXPERIMENT_KEY, Fe, i, t), !1;
        try {
            return this.setInForcedVariationMap(r, n, a), !0;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), !1;
        }
    }, e.prototype.getVariationFromExperimentRule = function(e, t, r, i, n) {
        void 0 === n && (n = {});
        var o = [], a = this.findValidatedForcedDecision(e, i, t, r.key);
        o.push.apply(o, a.reasons);
        var s = a.result;
        if (s) return {
            result: s.key,
            reasons: o
        };
        var u = this.getVariation(e, r, i, n);
        return o.push.apply(o, u.reasons), {
            result: u.result,
            reasons: o
        };
    }, e.prototype.getVariationFromDeliveryRule = function(e, t, r, i, n) {
        var o = [], a = !1, s = r[i], u = this.findValidatedForcedDecision(e, n, t, s.key);
        o.push.apply(o, u.reasons);
        var _$l = u.result;
        if (_$l) return {
            result: _$l,
            reasons: o,
            skipToEveryoneElse: a
        };
        var _$E, _$I, _$c, _$_, _$d, _$f = n.getUserId(), g = n.getAttributes(), p = this.getBucketingId(_$f, g), N = i === r.length - 1, v = N ? "Everyone Else" : i + 1, T = null, h = this.checkIfUserIsInAudience(e, s, A.RULE, g, v);
        return o.push.apply(o, h.reasons), h.result ? (this.logger.log(O.DEBUG, R.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE, Fe, _$f, v), o.push([
            R.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE,
            Fe,
            _$f,
            v
        ]), _$I = this.buildBucketerParams(e, s, p, _$f), _$c = ce(_$I), o.push.apply(o, _$c.reasons), (_$E = _$c.result) && (_$d = _$E, T = (_$_ = e).variationIdMap.hasOwnProperty(_$d) ? _$_.variationIdMap[_$d] : null), T ? (this.logger.log(O.DEBUG, R.USER_BUCKETED_INTO_TARGETING_RULE, Fe, _$f, v), o.push([
            R.USER_BUCKETED_INTO_TARGETING_RULE,
            Fe,
            _$f,
            v
        ])) : N || (this.logger.log(O.DEBUG, R.USER_NOT_BUCKETED_INTO_TARGETING_RULE, Fe, _$f, v), o.push([
            R.USER_NOT_BUCKETED_INTO_TARGETING_RULE,
            Fe,
            _$f,
            v
        ]), a = !0)) : (this.logger.log(O.DEBUG, R.USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE, Fe, _$f, v), o.push([
            R.USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE,
            Fe,
            _$f,
            v
        ])), {
            result: T,
            reasons: o,
            skipToEveryoneElse: a
        };
    }, e;
}();
function Pe(e, t) {
    if (e.hasOwnProperty("revenue")) {
        var r = e.revenue, i = void 0;
        return "string" == typeof r ? (i = parseInt(r), isNaN(i) ? (t.log(O.INFO, R.FAILED_TO_PARSE_REVENUE, "EVENT_TAG_UTILS", r), null) : (t.log(O.INFO, R.PARSED_REVENUE_VALUE, "EVENT_TAG_UTILS", i), i)) : "number" == typeof r ? (i = r, t.log(O.INFO, R.PARSED_REVENUE_VALUE, "EVENT_TAG_UTILS", i), i) : null;
    }
    return null;
}
function be(e, t) {
    if (e.hasOwnProperty("value")) {
        var r = e.value, i = void 0;
        return "string" == typeof r ? (i = parseFloat(r), isNaN(i) ? (t.log(O.INFO, R.FAILED_TO_PARSE_VALUE, "EVENT_TAG_UTILS", r), null) : (t.log(O.INFO, R.PARSED_NUMERIC_VALUE, "EVENT_TAG_UTILS", i), i)) : "number" == typeof r ? (i = r, t.log(O.INFO, R.PARSED_NUMERIC_VALUE, "EVENT_TAG_UTILS", i), i) : null;
    }
    return null;
}
function Ke(e, t) {
    return "string" == typeof e && ("string" == typeof t || "boolean" == typeof t || p.isNumber(t) && p.isSafeInteger(t));
}
var xe = "https://logx.optimizely.com/v1/events";
function ke(e) {
    var t = e.attributes, r = e.userId, i = e.clientEngine, n = e.clientVersion, o = e.configObj, a = e.logger, s = !!o.anonymizeIP && o.anonymizeIP, u = o.botFiltering, _$l = {
        snapshots: [],
        visitor_id: r,
        attributes: []
    }, _$E = {
        account_id: o.accountId,
        project_id: o.projectId,
        visitors: [
            _$l
        ],
        revision: o.revision,
        client_name: i,
        client_version: n,
        anonymize_ip: s,
        enrich_decisions: !0
    };
    return t && Object.keys(t || {}).forEach(function(e) {
        if (Ke(e, t[e])) {
            var r = W(o, e, a);
            r && _$E.visitors[0].attributes.push({
                entity_id: r,
                key: e,
                type: "custom",
                value: t[e]
            });
        }
    }), "boolean" == typeof u && _$E.visitors[0].attributes.push({
        entity_id: v.BOT_FILTERING,
        key: v.BOT_FILTERING,
        type: "custom",
        value: u
    }), _$E;
}
function Be(e) {
    var t, r, i, n, o, a, s, u, _$l, _$E = ke(e), _$I = (t = e.configObj, r = e.experimentId, i = e.variationId, n = e.ruleKey, o = e.ruleType, a = e.flagKey, s = e.enabled, u = r ? Z(t, r) : null, _$l = i ? Q(t, i) : null, {
        decisions: [
            {
                campaign_id: u,
                experiment_id: r,
                variation_id: i,
                metadata: {
                    flag_key: a,
                    rule_key: n,
                    rule_type: o,
                    variation_key: _$l = _$l || "",
                    enabled: s
                }
            }
        ],
        events: [
            {
                entity_id: u,
                timestamp: p.currentTimestamp(),
                key: "campaign_activated",
                uuid: p.uuid()
            }
        ]
    });
    return _$E.visitors[0].snapshots.push(_$I), {
        httpVerb: "POST",
        url: xe,
        params: _$E
    };
}
function Ge(e) {
    var t = ke(e), r = function(e, t, r, i) {
        var n = {
            events: []
        }, o = {
            entity_id: q(e, t),
            timestamp: p.currentTimestamp(),
            uuid: p.uuid(),
            key: t
        };
        if (i) {
            var a = Pe(i, r);
            null !== a && (o.revenue = a);
            var s = be(i, r);
            null !== s && (o.value = s), o.tags = i;
        }
        return n.events.push(o), n;
    }(e.configObj, e.eventKey, e.logger, e.eventTags);
    return t.visitors[0].snapshots = [
        r
    ], {
        httpVerb: "POST",
        url: xe,
        params: t
    };
}
function we(e) {
    var t, r;
    return null !== (r = null === (t = e.experiment) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}
function je(e) {
    var t, r;
    return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}
function Ye(e) {
    var t, r;
    return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.featureEnabled) && void 0 !== r && r;
}
function He(e) {
    var t, r;
    return null !== (r = null === (t = e.experiment) || void 0 === t ? void 0 : t.id) && void 0 !== r ? r : null;
}
function Xe(e) {
    var t, r;
    return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.id) && void 0 !== r ? r : null;
}
var ze = $8NKT3.getLogger("EVENT_BUILDER");
function Je(e, t) {
    var r = [];
    return t && Object.keys(t || {}).forEach(function(i) {
        if (Ke(i, t[i])) {
            var n = W(e, i, ze);
            n && r.push({
                entityId: n,
                key: i,
                value: t[i]
            });
        }
    }), r;
}
var Ze = "USER_PROFILE_SERVICE_VALIDATOR";
var We = function() {
    function e(e) {
        var t, r = this, i = e.clientEngine;
        i || (e.logger.log(O.INFO, R.INVALID_CLIENT_ENGINE, "OPTIMIZELY", i), i = "node-sdk"), this.clientEngine = i, this.clientVersion = e.clientVersion || "4.10.0", this.errorHandler = e.errorHandler, this.isOptimizelyConfigValid = e.isValidInstance, this.logger = e.logger;
        var n = null !== (t = e.defaultDecideOptions) && void 0 !== t ? t : [];
        Array.isArray(n) || (this.logger.log(O.DEBUG, R.INVALID_DEFAULT_DECIDE_OPTIONS, "OPTIMIZELY"), n = []);
        var o = {};
        n.forEach(function(e) {
            exports.OptimizelyDecideOption[e] ? o[e] = !0 : r.logger.log(O.WARNING, R.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e);
        }), this.defaultDecideOptions = o, this.projectConfigManager = function(e) {
            return new Ee(e);
        }({
            datafile: e.datafile,
            jsonSchemaValidator: e.jsonSchemaValidator,
            sdkKey: e.sdkKey,
            datafileManager: e.datafileManager
        }), this.disposeOnUpdate = this.projectConfigManager.onUpdate(function(e) {
            r.logger.log(O.INFO, R.UPDATED_OPTIMIZELY_CONFIG, "OPTIMIZELY", e.revision, e.projectId), r.notificationCenter.sendNotifications(g.OPTIMIZELY_CONFIG_UPDATE);
        });
        var a, s = this.projectConfigManager.onReady(), u = null;
        if (e.userProfileService) try {
            (function(e) {
                if ("object" == typeof e && null !== e) {
                    if ("function" != typeof e.lookup) throw new Error(f(N.INVALID_USER_PROFILE_SERVICE, Ze, "Missing function 'lookup'"));
                    if ("function" != typeof e.save) throw new Error(f(N.INVALID_USER_PROFILE_SERVICE, Ze, "Missing function 'save'"));
                    return !0;
                }
                throw new Error(f(N.INVALID_USER_PROFILE_SERVICE, Ze));
            })(e.userProfileService) && (u = e.userProfileService, this.logger.log(O.INFO, R.VALID_USER_PROFILE_SERVICE, "OPTIMIZELY"));
        } catch (e) {
            this.logger.log(O.WARNING, e.message);
        }
        this.decisionService = (a = {
            userProfileService: u,
            logger: this.logger,
            UNSTABLE_conditionEvaluators: e.UNSTABLE_conditionEvaluators
        }, new Me(a)), this.notificationCenter = e.notificationCenter, this.eventProcessor = e.eventProcessor;
        var _$l = this.eventProcessor.start();
        this.readyPromise = Promise.all([
            s,
            _$l
        ]).then(function(e) {
            return e[0];
        }), this.readyTimeouts = {}, this.nextReadyTimeoutId = 0;
    }
    return e.prototype.isValidInstance = function() {
        return this.isOptimizelyConfigValid && !!this.projectConfigManager.getConfig();
    }, e.prototype.activate = function(e, t, r) {
        try {
            if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "activate"), null;
            if (!this.validateInputs({
                experiment_key: e,
                user_id: t
            }, r)) return this.notActivatingExperiment(e, t);
            var i = this.projectConfigManager.getConfig();
            if (!i) return null;
            try {
                var n = this.getVariation(e, t, r);
                if (null === n) return this.notActivatingExperiment(e, t);
                if (!function(e, t) {
                    return "Running" === $(e, t);
                }(i, e)) return this.logger.log(O.DEBUG, R.SHOULD_NOT_DISPATCH_ACTIVATE, "OPTIMIZELY", e), n;
                var o = ee(i, e), a = {
                    experiment: o,
                    variation: o.variationKeyMap[n],
                    decisionSource: h.EXPERIMENT
                };
                return this.sendImpressionEvent(a, "", t, !0, r), n;
            } catch (r) {
                return this.logger.log(O.ERROR, r.message), this.logger.log(O.INFO, R.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e), this.errorHandler.handleError(r), null;
            }
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.sendImpressionEvent = function(e, t, r, i, n) {
        var o = this.projectConfigManager.getConfig();
        if (o) {
            var a = function(e) {
                var _$t = e.configObj, _$r = e.decisionObj, _$i = e.userId, _$n = e.flagKey, o = e.enabled, a = e.userAttributes, s = e.clientEngine, u = e.clientVersion, _$l = _$r.decisionSource, _$E = we(_$r), _$I = He(_$r), _$c = je(_$r), _$_ = Xe(_$r), _$d = null !== _$I ? Z(_$t, _$I) : null;
                return {
                    type: "impression",
                    timestamp: p.currentTimestamp(),
                    uuid: p.uuid(),
                    user: {
                        id: _$i,
                        attributes: Je(_$t, a)
                    },
                    context: {
                        accountId: _$t.accountId,
                        projectId: _$t.projectId,
                        revision: _$t.revision,
                        clientName: s,
                        clientVersion: u,
                        anonymizeIP: _$t.anonymizeIP || !1,
                        botFiltering: _$t.botFiltering
                    },
                    layer: {
                        id: _$d
                    },
                    experiment: {
                        id: _$I,
                        key: _$E
                    },
                    variation: {
                        id: _$_,
                        key: _$c
                    },
                    ruleKey: _$E,
                    flagKey: _$n,
                    ruleType: _$l,
                    enabled: o
                };
            }({
                decisionObj: e,
                flagKey: t,
                enabled: i,
                userId: r,
                userAttributes: n,
                clientEngine: this.clientEngine,
                clientVersion: this.clientVersion,
                configObj: o
            });
            this.eventProcessor.process(a), this.emitNotificationCenterActivate(e, t, r, i, n);
        }
    }, e.prototype.emitNotificationCenterActivate = function(e, t, r, i, n) {
        var o = this.projectConfigManager.getConfig();
        if (o) {
            var a, s = e.decisionSource, u = we(e), _$l = He(e), _$E = je(e), _$I = Xe(e);
            null !== _$l && "" !== _$E && (a = o.experimentIdMap[_$l]);
            var _$c, _$_ = Be({
                attributes: n,
                clientEngine: this.clientEngine,
                clientVersion: this.clientVersion,
                configObj: o,
                experimentId: _$l,
                ruleKey: u,
                flagKey: t,
                ruleType: s,
                userId: r,
                enabled: i,
                variationId: _$I,
                logger: this.logger
            });
            a && a.variationKeyMap && "" !== _$E && (_$c = a.variationKeyMap[_$E]), this.notificationCenter.sendNotifications(g.ACTIVATE, {
                experiment: a,
                userId: r,
                attributes: n,
                variation: _$c,
                logEvent: _$_
            });
        }
    }, e.prototype.track = function(e, t, r, i) {
        try {
            if (!this.isValidInstance()) return void this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "track");
            if (!this.validateInputs({
                user_id: t,
                event_key: e
            }, r, i)) return;
            var n = this.projectConfigManager.getConfig();
            if (!n) return;
            if (!function(e, t) {
                return e.eventKeyMap.hasOwnProperty(t);
            }(n, e)) return this.logger.log(O.WARNING, R.EVENT_KEY_NOT_FOUND, "OPTIMIZELY", e), void this.logger.log(O.WARNING, R.NOT_TRACKING_USER, "OPTIMIZELY", t);
            var o = function(e) {
                var _$t = e.configObj, _$r = e.userId, _$i = e.userAttributes, n = e.clientEngine, o = e.clientVersion, a = e.eventKey, s = e.eventTags, u = q(_$t, a), _$l = s ? Pe(s, ze) : null, _$E = s ? be(s, ze) : null;
                return {
                    type: "conversion",
                    timestamp: p.currentTimestamp(),
                    uuid: p.uuid(),
                    user: {
                        id: _$r,
                        attributes: Je(_$t, _$i)
                    },
                    context: {
                        accountId: _$t.accountId,
                        projectId: _$t.projectId,
                        revision: _$t.revision,
                        clientName: n,
                        clientVersion: o,
                        anonymizeIP: _$t.anonymizeIP || !1,
                        botFiltering: _$t.botFiltering
                    },
                    event: {
                        id: u,
                        key: a
                    },
                    revenue: _$l,
                    value: _$E,
                    tags: s
                };
            }({
                eventKey: e,
                eventTags: i = this.filterEmptyValues(i),
                userId: t,
                userAttributes: r,
                clientEngine: this.clientEngine,
                clientVersion: this.clientVersion,
                configObj: n
            });
            this.logger.log(O.INFO, R.TRACK_EVENT, "OPTIMIZELY", e, t), this.eventProcessor.process(o), this.emitNotificationCenterTrack(e, t, r, i);
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), this.logger.log(O.ERROR, R.NOT_TRACKING_USER, "OPTIMIZELY", t);
        }
    }, e.prototype.emitNotificationCenterTrack = function(e, t, r, i) {
        try {
            var n = this.projectConfigManager.getConfig();
            if (!n) return;
            var o = Ge({
                attributes: r,
                clientEngine: this.clientEngine,
                clientVersion: this.clientVersion,
                configObj: n,
                eventKey: e,
                eventTags: i,
                logger: this.logger,
                userId: t
            });
            this.notificationCenter.sendNotifications(g.TRACK, {
                eventKey: e,
                userId: t,
                attributes: r,
                eventTags: i,
                logEvent: o
            });
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e);
        }
    }, e.prototype.getVariation = function(e, t, r) {
        try {
            if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getVariation"), null;
            try {
                if (!this.validateInputs({
                    experiment_key: e,
                    user_id: t
                }, r)) return null;
                var i = this.projectConfigManager.getConfig();
                if (!i) return null;
                var n = i.experimentKeyMap[e];
                if (!n) return this.logger.log(O.DEBUG, N.INVALID_EXPERIMENT_KEY, "OPTIMIZELY", e), null;
                var o = this.decisionService.getVariation(i, n, this.createUserContext(t, r)).result, a = (s = i, u = n.id, s.experimentFeatureMap.hasOwnProperty(u) ? T.FEATURE_TEST : T.AB_TEST);
                return this.notificationCenter.sendNotifications(g.DECISION, {
                    type: a,
                    userId: t,
                    attributes: r || {},
                    decisionInfo: {
                        experimentKey: e,
                        variationKey: o
                    }
                }), o;
            } catch (e) {
                return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
            }
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
        var s, u;
    }, e.prototype.setForcedVariation = function(e, t, r) {
        if (!this.validateInputs({
            experiment_key: e,
            user_id: t
        })) return !1;
        var i = this.projectConfigManager.getConfig();
        if (!i) return !1;
        try {
            return this.decisionService.setForcedVariation(i, e, t, r);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), !1;
        }
    }, e.prototype.getForcedVariation = function(e, t) {
        if (!this.validateInputs({
            experiment_key: e,
            user_id: t
        })) return null;
        var r = this.projectConfigManager.getConfig();
        if (!r) return null;
        try {
            return this.decisionService.getForcedVariation(r, e, t).result;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.validateInputs = function(e, t, r) {
        try {
            if (e.hasOwnProperty("user_id")) {
                var i = e.user_id;
                if ("string" != typeof i || null === i || "undefined" === i) throw new Error(f(N.INVALID_INPUT_FORMAT, "OPTIMIZELY", "user_id"));
                delete e.user_id;
            }
            return Object.keys(e).forEach(function(t) {
                if (!Ce(e[t])) throw new Error(f(N.INVALID_INPUT_FORMAT, "OPTIMIZELY", t));
            }), t && function(e) {
                if ("object" != typeof e || Array.isArray(e) || null === e) throw new Error(f(N.INVALID_ATTRIBUTES, "ATTRIBUTES_VALIDATOR"));
                Object.keys(e).forEach(function(t) {
                    if (void 0 === e[t]) throw new Error(f(N.UNDEFINED_ATTRIBUTE, "ATTRIBUTES_VALIDATOR", t));
                });
            }(t), r && function(e) {
                if ("object" != typeof e || Array.isArray(e) || null === e) throw new Error(f(N.INVALID_EVENT_TAGS, "EVENT_TAGS_VALIDATOR"));
            }(r), !0;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), !1;
        }
    }, e.prototype.notActivatingExperiment = function(e, t) {
        return this.logger.log(O.INFO, R.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e), null;
    }, e.prototype.filterEmptyValues = function(e) {
        for(var t in e)!e.hasOwnProperty(t) || null !== e[t] && void 0 !== e[t] || delete e[t];
        return e;
    }, e.prototype.isFeatureEnabled = function(e, t, r) {
        try {
            if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "isFeatureEnabled"), !1;
            if (!this.validateInputs({
                feature_key: e,
                user_id: t
            }, r)) return !1;
            var i = this.projectConfigManager.getConfig();
            if (!i) return !1;
            var n = ne(i, e, this.logger);
            if (!n) return !1;
            var o = {}, a = this.createUserContext(t, r), s = this.decisionService.getVariationForFeature(i, n, a).result, u = s.decisionSource, _$l = we(s), _$E = je(s), _$I = Ye(s);
            u === h.FEATURE_TEST && (o = {
                experimentKey: _$l,
                variationKey: _$E
            }), (u === h.FEATURE_TEST || u === h.ROLLOUT && se(i)) && this.sendImpressionEvent(s, n.key, t, _$I, r), !0 === _$I ? this.logger.log(O.INFO, R.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", e, t) : (this.logger.log(O.INFO, R.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", e, t), _$I = !1);
            var _$c = {
                featureKey: e,
                featureEnabled: _$I,
                source: s.decisionSource,
                sourceInfo: o
            };
            return this.notificationCenter.sendNotifications(g.DECISION, {
                type: T.FEATURE,
                userId: t,
                attributes: r || {},
                decisionInfo: _$c
            }), _$I;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), !1;
        }
    }, e.prototype.getEnabledFeatures = function(e, t) {
        var r = this;
        try {
            var i = [];
            if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getEnabledFeatures"), i;
            if (!this.validateInputs({
                user_id: e
            })) return i;
            var n = this.projectConfigManager.getConfig();
            return n ? (I(n.featureKeyMap).forEach(function(n) {
                r.isFeatureEnabled(n.key, e, t) && i.push(n.key);
            }), i) : i;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), [];
        }
    }, e.prototype.getFeatureVariable = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, null, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariable"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getFeatureVariableForType = function(e, t, r, i, n) {
        if (!this.validateInputs({
            feature_key: e,
            variable_key: t,
            user_id: i
        }, n)) return null;
        var o = this.projectConfigManager.getConfig();
        if (!o) return null;
        var a = ne(o, e, this.logger);
        if (!a) return null;
        var s = function(e, t, r, i) {
            var _$n = e.featureKeyMap[t];
            if (!_$n) return i.log(O.ERROR, N.FEATURE_NOT_IN_DATAFILE, z, t), null;
            var o = _$n.variableKeyMap[r];
            return o || (i.log(O.ERROR, N.VARIABLE_KEY_NOT_IN_DATAFILE, z, r, t), null);
        }(o, e, t, this.logger);
        if (!s) return null;
        if (r && s.type !== r) return this.logger.log(O.WARNING, R.VARIABLE_REQUESTED_WITH_WRONG_TYPE, "OPTIMIZELY", r, s.type), null;
        var u = this.createUserContext(i, n), _$l = this.decisionService.getVariationForFeature(o, a, u).result, _$E = Ye(_$l), _$I = this.getFeatureVariableValueFromVariation(e, _$E, _$l.variation, s, i), _$c = {};
        return _$l.decisionSource === h.FEATURE_TEST && null !== _$l.experiment && null !== _$l.variation && (_$c = {
            experimentKey: _$l.experiment.key,
            variationKey: _$l.variation.key
        }), this.notificationCenter.sendNotifications(g.DECISION, {
            type: T.FEATURE_VARIABLE,
            userId: i,
            attributes: n || {},
            decisionInfo: {
                featureKey: e,
                featureEnabled: _$E,
                source: _$l.decisionSource,
                variableKey: t,
                variableValue: _$I,
                variableType: s.type,
                sourceInfo: _$c
            }
        }), _$I;
    }, e.prototype.getFeatureVariableValueFromVariation = function(e, t, r, i, n) {
        var o = this.projectConfigManager.getConfig();
        if (!o) return null;
        var a = i.defaultValue;
        if (null !== r) {
            var s = function(e, t, r, i) {
                if (!t || !r) return null;
                if (!e.variationVariableUsageMap.hasOwnProperty(r.id)) return i.log(O.ERROR, N.VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT, z, r.id), null;
                var _$n = e.variationVariableUsageMap[r.id][t.id];
                return _$n ? _$n.value : null;
            }(o, i, r, this.logger);
            null !== s ? t ? (a = s, this.logger.log(O.INFO, R.USER_RECEIVED_VARIABLE_VALUE, "OPTIMIZELY", a, i.key, e)) : this.logger.log(O.INFO, R.FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", e, n, a) : this.logger.log(O.INFO, R.VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", i.key, r.key);
        } else this.logger.log(O.INFO, R.USER_RECEIVED_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", n, i.key, e);
        return function(e, t, r) {
            var _$i;
            switch(t){
                case y.BOOLEAN:
                    "true" !== e && "false" !== e ? (r.log(O.ERROR, N.UNABLE_TO_CAST_VALUE, z, e, t), _$i = null) : _$i = "true" === e;
                    break;
                case y.INTEGER:
                    _$i = parseInt(e, 10), isNaN(_$i) && (r.log(O.ERROR, N.UNABLE_TO_CAST_VALUE, z, e, t), _$i = null);
                    break;
                case y.DOUBLE:
                    _$i = parseFloat(e), isNaN(_$i) && (r.log(O.ERROR, N.UNABLE_TO_CAST_VALUE, z, e, t), _$i = null);
                    break;
                case y.JSON:
                    try {
                        _$i = JSON.parse(e);
                    } catch (n) {
                        r.log(O.ERROR, N.UNABLE_TO_CAST_VALUE, z, e, t), _$i = null;
                    }
                    break;
                default:
                    _$i = e;
            }
            return _$i;
        }(a, i.type, this.logger);
    }, e.prototype.getFeatureVariableBoolean = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, y.BOOLEAN, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableBoolean"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getFeatureVariableDouble = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, y.DOUBLE, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableDouble"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getFeatureVariableInteger = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, y.INTEGER, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableInteger"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getFeatureVariableString = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, y.STRING, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableString"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getFeatureVariableJSON = function(e, t, r, i) {
        try {
            return this.isValidInstance() ? this.getFeatureVariableForType(e, t, y.JSON, r, i) : (this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableJSON"), null);
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getAllFeatureVariables = function(e, t, r) {
        var i = this;
        try {
            if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "getAllFeatureVariables"), null;
            if (!this.validateInputs({
                feature_key: e,
                user_id: t
            }, r)) return null;
            var n = this.projectConfigManager.getConfig();
            if (!n) return null;
            var o = ne(n, e, this.logger);
            if (!o) return null;
            var a = this.createUserContext(t, r), s = this.decisionService.getVariationForFeature(n, o, a).result, u = Ye(s), _$l = {};
            o.variables.forEach(function(r) {
                _$l[r.key] = i.getFeatureVariableValueFromVariation(e, u, s.variation, r, t);
            });
            var _$E = {};
            return s.decisionSource === h.FEATURE_TEST && null !== s.experiment && null !== s.variation && (_$E = {
                experimentKey: s.experiment.key,
                variationKey: s.variation.key
            }), this.notificationCenter.sendNotifications(g.DECISION, {
                type: T.ALL_FEATURE_VARIABLES,
                userId: t,
                attributes: r || {},
                decisionInfo: {
                    featureKey: e,
                    featureEnabled: u,
                    source: s.decisionSource,
                    variableValues: _$l,
                    sourceInfo: _$E
                }
            }), _$l;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.getOptimizelyConfig = function() {
        try {
            return this.projectConfigManager.getConfig() ? this.projectConfigManager.getOptimizelyConfig() : null;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
    }, e.prototype.close = function() {
        var _$e = this;
        try {
            var t = this.eventProcessor.stop();
            return this.disposeOnUpdate && (this.disposeOnUpdate(), this.disposeOnUpdate = null), this.projectConfigManager && this.projectConfigManager.stop(), Object.keys(this.readyTimeouts).forEach(function(t) {
                var r = _$e.readyTimeouts[t];
                clearTimeout(r.readyTimeout), r.onClose();
            }), this.readyTimeouts = {}, t.then(function() {
                return {
                    success: !0
                };
            }, function(e) {
                return {
                    success: !1,
                    reason: String(e)
                };
            });
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), Promise.resolve({
                success: !1,
                reason: String(e)
            });
        }
    }, e.prototype.onReady = function(e) {
        var t, r, i = this;
        "object" == typeof e && null !== e && void 0 !== e.timeout && (t = e.timeout), p.isSafeInteger(t) || (t = 3e4);
        var n = new Promise(function(e) {
            r = e;
        }), o = this.nextReadyTimeoutId;
        this.nextReadyTimeoutId++;
        var a = setTimeout(function() {
            delete i.readyTimeouts[o], r({
                success: !1,
                reason: f("onReady timeout expired after %s ms", t)
            });
        }, t);
        return this.readyTimeouts[o] = {
            readyTimeout: a,
            onClose: function onClose() {
                r({
                    success: !1,
                    reason: "Instance closed"
                });
            }
        }, this.readyPromise.then(function() {
            clearTimeout(a), delete i.readyTimeouts[o], r({
                success: !0
            });
        }), Promise.race([
            this.readyPromise,
            n
        ]);
    }, e.prototype.createUserContext = function(e, t) {
        return this.validateInputs({
            user_id: e
        }, t) ? new j({
            optimizely: this,
            userId: e,
            attributes: t
        }) : null;
    }, e.prototype.decide = function(e, t, r) {
        var i, n, o, a, u = this;
        void 0 === r && (r = []);
        var _$l, _$E = e.getUserId(), _$I = e.getAttributes(), _$c = this.projectConfigManager.getConfig(), _$_ = [];
        if (!this.isValidInstance() || !_$c) return this.logger.log(O.INFO, R.INVALID_OBJECT, "OPTIMIZELY", "decide"), w(t, e, [
            D.SDK_NOT_READY
        ]);
        var _$d = _$c.featureKeyMap[t];
        if (!_$d) return this.logger.log(O.ERROR, N.FEATURE_NOT_IN_DATAFILE, "OPTIMIZELY", t), w(t, e, [
            f(D.FLAG_KEY_INVALID, t)
        ]);
        var p = this.getAllDecideOptions(r), v = this.decisionService.findValidatedForcedDecision(_$c, e, t);
        _$_.push.apply(_$_, v.reasons);
        var A = v.result;
        if (A) _$l = {
            experiment: null,
            variation: A,
            decisionSource: h.FEATURE_TEST
        };
        else {
            var y = this.decisionService.getVariationForFeature(_$c, _$d, e, p);
            _$_.push.apply(_$_, y.reasons), _$l = y.result;
        }
        var U = _$l.decisionSource, S = null !== (n = null === (i = _$l.experiment) || void 0 === i ? void 0 : i.key) && void 0 !== n ? n : null, L = null !== (a = null === (o = _$l.variation) || void 0 === o ? void 0 : o.key) && void 0 !== a ? a : null, m = Ye(_$l);
        !0 === m ? this.logger.log(O.INFO, R.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", t, _$E) : this.logger.log(O.INFO, R.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", t, _$E);
        var V = {}, C = !1;
        p[exports.OptimizelyDecideOption.EXCLUDE_VARIABLES] || _$d.variables.forEach(function(e) {
            V[e.key] = u.getFeatureVariableValueFromVariation(t, m, _$l.variation, e, _$E);
        }), !p[exports.OptimizelyDecideOption.DISABLE_DECISION_EVENT] && (U === h.FEATURE_TEST || U === h.ROLLOUT && se(_$c)) && (this.sendImpressionEvent(_$l, t, _$E, m, _$I), C = !0);
        var F = [];
        p[exports.OptimizelyDecideOption.INCLUDE_REASONS] && (F = _$_.map(function(e) {
            return f.apply(void 0, s([
                e[0]
            ], e.slice(1)));
        }));
        var M = {
            flagKey: t,
            enabled: m,
            variationKey: L,
            ruleKey: S,
            variables: V,
            reasons: F,
            decisionEventDispatched: C
        };
        return this.notificationCenter.sendNotifications(g.DECISION, {
            type: T.FLAG,
            userId: _$E,
            attributes: _$I,
            decisionInfo: M
        }), {
            variationKey: L,
            enabled: m,
            variables: V,
            ruleKey: S,
            flagKey: t,
            userContext: e,
            reasons: F
        };
    }, e.prototype.getAllDecideOptions = function(e) {
        var t = this, r = a({}, this.defaultDecideOptions);
        return Array.isArray(e) ? e.forEach(function(e) {
            exports.OptimizelyDecideOption[e] ? r[e] = !0 : t.logger.log(O.WARNING, R.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e);
        }) : this.logger.log(O.DEBUG, R.INVALID_DECIDE_OPTIONS, "OPTIMIZELY"), r;
    }, e.prototype.decideForKeys = function(e, t, r) {
        var i = this;
        void 0 === r && (r = []);
        var n = {};
        if (!this.isValidInstance()) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "decideForKeys"), n;
        if (0 === t.length) return n;
        var o = this.getAllDecideOptions(r);
        return t.forEach(function(t) {
            var a = i.decide(e, t, r);
            o[exports.OptimizelyDecideOption.ENABLED_FLAGS_ONLY] && !a.enabled || (n[t] = a);
        }), n;
    }, e.prototype.decideAll = function(e, t) {
        void 0 === t && (t = []);
        var r = this.projectConfigManager.getConfig();
        if (!this.isValidInstance() || !r) return this.logger.log(O.ERROR, R.INVALID_OBJECT, "OPTIMIZELY", "decideAll"), {};
        var i = Object.keys(r.featureKeyMap);
        return this.decideForKeys(e, i, t);
    }, e;
}(), qe = function qe(e) {
    return !("number" != typeof e || !p.isSafeInteger(e)) && e >= 1;
}, $e = function $e(e) {
    return !("number" != typeof e || !p.isSafeInteger(e)) && e > 0;
}, Qe = function() {
    function e(e) {
        var t = this;
        this.logger = e.logger, this.errorHandler = e.errorHandler, this.notificationListeners = {}, I(g).forEach(function(e) {
            t.notificationListeners[e] = [];
        }), this.listenerId = 1;
    }
    return e.prototype.addNotificationListener = function(e, t) {
        try {
            if (!(I(g).indexOf(e) > -1)) return -1;
            this.notificationListeners[e] || (this.notificationListeners[e] = []);
            var r = !1;
            if ((this.notificationListeners[e] || []).forEach(function(e) {
                e.callback !== t || (r = !0);
            }), r) return -1;
            this.notificationListeners[e].push({
                id: this.listenerId,
                callback: t
            });
            var i = this.listenerId;
            return this.listenerId += 1, i;
        } catch (e) {
            return this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e), -1;
        }
    }, e.prototype.removeNotificationListener = function(e) {
        var t = this;
        try {
            var r, i;
            if (Object.keys(this.notificationListeners).some(function(n) {
                return (t.notificationListeners[n] || []).every(function(t, o) {
                    return t.id !== e || (r = o, i = n, !1);
                }), void 0 !== r && void 0 !== i;
            }), void 0 !== r && void 0 !== i) return this.notificationListeners[i].splice(r, 1), !0;
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e);
        }
        return !1;
    }, e.prototype.clearAllNotificationListeners = function() {
        var _$e = this;
        try {
            I(g).forEach(function(t) {
                _$e.notificationListeners[t] = [];
            });
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e);
        }
    }, e.prototype.clearNotificationListeners = function(e) {
        try {
            this.notificationListeners[e] = [];
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e);
        }
    }, e.prototype.sendNotifications = function(e, t) {
        var r = this;
        try {
            (this.notificationListeners[e] || []).forEach(function(i) {
                var n = i.callback;
                try {
                    n(t);
                } catch (t) {
                    r.logger.log(O.ERROR, R.NOTIFICATION_LISTENER_EXCEPTION, "NOTIFICATION_CENTER", e, t.message);
                }
            });
        } catch (e) {
            this.logger.log(O.ERROR, e.message), this.errorHandler.handleError(e);
        }
    }, e;
}();
var et = {
    createEventProcessor: function createEventProcessor() {
        for(var _$e = [], t = 0; t < arguments.length; t++)_$e[t] = arguments[t];
        return new ($l1o0O.LogTierV1EventProcessor.bind.apply($l1o0O.LogTierV1EventProcessor, s([
            void 0
        ], _$e)));
    },
    LocalStoragePendingEventsDispatcher: $l1o0O.LocalStoragePendingEventsDispatcher
};
function tt(e, t, r, i) {
    var n = {
        sdkKey: e
    };
    if ((void 0 === i || "object" == typeof i && null !== i) && p.assign(n, i), r) {
        var a = ae({
            datafile: r,
            jsonSchemaValidator: void 0,
            logger: t
        }), s = a.configObj, u = a.error;
        u && t.error(u), s && (n.datafile = oe(s));
    }
    return new $5lUdl.HttpPollingDatafileManager(n);
}
var rt = $8NKT3.getLogger();
$8NKT3.setLogHandler(x()), $8NKT3.setLogLevel($8NKT3.LogLevel.INFO);
var it = !1, nt = function nt(e) {
    try {
        var i = !1;
        e.errorHandler && $8NKT3.setErrorHandler(e.errorHandler), e.logger && ($8NKT3.setLogHandler(e.logger), $8NKT3.setLogLevel($8NKT3.LogLevel.NOTSET)), void 0 !== e.logLevel && $8NKT3.setLogLevel(e.logLevel);
        try {
            V(e), i = !0;
        } catch (e) {
            rt.error(e);
        }
        var n = void 0;
        null == e.eventDispatcher ? (n = new $l1o0O.LocalStoragePendingEventsDispatcher({
            eventDispatcher: P
        }), it || (n.sendPendingEvents(), it = !0)) : n = e.eventDispatcher;
        var o = e.closingEventDispatcher;
        !e.eventDispatcher && !o && window.navigator && "sendBeacon" in window.navigator && (o = b);
        var s = e.eventBatchSize, u = e.eventFlushInterval;
        qe(e.eventBatchSize) || (rt.warn("Invalid eventBatchSize %s, defaulting to %s", e.eventBatchSize, 10), s = 10), $e(e.eventFlushInterval) || (rt.warn("Invalid eventFlushInterval %s, defaulting to %s", e.eventFlushInterval, 1e3), u = 1e3);
        var _$l = $8NKT3.getErrorHandler(), _$E = new Qe({
            logger: rt,
            errorHandler: _$l
        }), _$I = {
            dispatcher: n,
            closingDispatcher: o,
            flushInterval: u,
            batchSize: s,
            maxQueueSize: e.eventMaxQueueSize || 1e4,
            notificationCenter: _$E
        }, _$c = a(a({
            clientEngine: "javascript-sdk"
        }, e), {
            eventProcessor: et.createEventProcessor(_$I),
            logger: rt,
            errorHandler: _$l,
            datafileManager: e.sdkKey ? tt(e.sdkKey, rt, e.datafile, e.datafileOptions) : void 0,
            notificationCenter: _$E,
            isValidInstance: i
        }), _$_ = new We(_$c);
        try {
            if ("function" == typeof window.addEventListener) {
                var _$d = "onpagehide" in window ? "pagehide" : "unload";
                window.addEventListener(_$d, function() {
                    _$_.close();
                }, !1);
            }
        } catch (e) {
            rt.error(R.UNABLE_TO_ATTACH_UNLOAD, "INDEX_BROWSER", e.message);
        }
        return _$_;
    } catch (e) {
        return rt.error(e), null;
    }
}, ot = function ot() {
    it = !1;
}, at = {
    logging: G,
    errorHandler: F,
    eventDispatcher: P,
    sendBeaconEventDispatcher: b,
    enums: S,
    setLogger: $8NKT3.setLogHandler,
    setLogLevel: $8NKT3.setLogLevel,
    createInstance: nt,
    __internalResetRetryState: ot,
    OptimizelyDecideOption: exports.OptimizelyDecideOption
};
Object.defineProperty(exports, "setLogLevel", {
    enumerable: !0,
    get: function get() {
        return $8NKT3.setLogLevel;
    }
}), Object.defineProperty(exports, "setLogger", {
    enumerable: !0,
    get: function get() {
        return $8NKT3.setLogHandler;
    }
}), exports.__internalResetRetryState = ot, exports.createInstance = nt, exports.default = at, exports.enums = S, exports.errorHandler = F, exports.eventDispatcher = P, exports.logging = G, exports.sendBeaconEventDispatcher = b;

});
parcelRegister("aRmx5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e80551eb5ef7e89$export$5f0017c582d45a2d; });
function $7e80551eb5ef7e89$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("8NKT3", function(module, exports) {
"use strict";
function $66874520a0612633$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
 * Copyright 2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $66874520a0612633$var$__export((parcelRequire("b2M7F")));

$66874520a0612633$var$__export((parcelRequire("7XZb9")));

$66874520a0612633$var$__export((parcelRequire("eVBTu")));

});
parcelRegister("b2M7F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @export
 * @class NoopErrorHandler
 * @implements {ErrorHandler}
 */ var $80a535c3b409fe46$var$NoopErrorHandler = /** @class */ function() {
    function NoopErrorHandler() {}
    /**
     * @param {Error} exception
     * @memberof NoopErrorHandler
     */ NoopErrorHandler.prototype.handleError = function(exception) {
        // no-op
        return;
    };
    return NoopErrorHandler;
}();
module.exports.NoopErrorHandler = $80a535c3b409fe46$var$NoopErrorHandler;
var $80a535c3b409fe46$var$globalErrorHandler = new $80a535c3b409fe46$var$NoopErrorHandler();
/**
 * @export
 * @param {ErrorHandler} handler
 */ function $80a535c3b409fe46$var$setErrorHandler(handler) {
    $80a535c3b409fe46$var$globalErrorHandler = handler;
}
module.exports.setErrorHandler = $80a535c3b409fe46$var$setErrorHandler;
/**
 * @export
 * @returns {ErrorHandler}
 */ function $80a535c3b409fe46$var$getErrorHandler() {
    return $80a535c3b409fe46$var$globalErrorHandler;
}
module.exports.getErrorHandler = $80a535c3b409fe46$var$getErrorHandler;
/**
 * @export
 */ function $80a535c3b409fe46$var$resetErrorHandler() {
    $80a535c3b409fe46$var$globalErrorHandler = new $80a535c3b409fe46$var$NoopErrorHandler();
}
module.exports.resetErrorHandler = $80a535c3b409fe46$var$resetErrorHandler;

});

parcelRegister("7XZb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Copyright 2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5ccd7fedce0be438$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["NOTSET"] = 0] = "NOTSET";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})($5ccd7fedce0be438$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));

});

parcelRegister("eVBTu", function(module, exports) {
"use strict";
var __spreadArrays = this && this.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $b2M7F = parcelRequire("b2M7F");

var $e1zbx = parcelRequire("e1zbx");

var $7XZb9 = parcelRequire("7XZb9");
var stringToLogLevel = {
    NOTSET: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4
};
function coerceLogLevel(level) {
    if (typeof level !== "string") return level;
    level = level.toUpperCase();
    if (level === "WARN") level = "WARNING";
    if (!stringToLogLevel[level]) return level;
    return stringToLogLevel[level];
}
var DefaultLogManager = /** @class */ function() {
    function DefaultLogManager() {
        this.defaultLoggerFacade = new OptimizelyLogger();
        this.loggers = {};
    }
    DefaultLogManager.prototype.getLogger = function(name) {
        if (!name) return this.defaultLoggerFacade;
        if (!this.loggers[name]) this.loggers[name] = new OptimizelyLogger({
            messagePrefix: name
        });
        return this.loggers[name];
    };
    return DefaultLogManager;
}();
var ConsoleLogHandler = /** @class */ function() {
    /**
     * Creates an instance of ConsoleLogger.
     * @param {ConsoleLogHandlerConfig} config
     * @memberof ConsoleLogger
     */ function ConsoleLogHandler(config) {
        if (config === void 0) config = {};
        this.logLevel = $7XZb9.LogLevel.NOTSET;
        if (config.logLevel !== undefined && $e1zbx.isValidEnum($7XZb9.LogLevel, config.logLevel)) this.setLogLevel(config.logLevel);
        this.logToConsole = config.logToConsole !== undefined ? !!config.logToConsole : true;
        this.prefix = config.prefix !== undefined ? config.prefix : "[OPTIMIZELY]";
    }
    /**
     * @param {LogLevel} level
     * @param {string} message
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.log = function(level, message) {
        if (!this.shouldLog(level) || !this.logToConsole) return;
        var logMessage = this.prefix + " - " + this.getLogLevelName(level) + " " + this.getTime() + " " + message;
        this.consoleLog(level, [
            logMessage
        ]);
    };
    /**
     * @param {LogLevel} level
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.setLogLevel = function(level) {
        level = coerceLogLevel(level);
        if (!$e1zbx.isValidEnum($7XZb9.LogLevel, level) || level === undefined) this.logLevel = $7XZb9.LogLevel.ERROR;
        else this.logLevel = level;
    };
    /**
     * @returns {string}
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.getTime = function() {
        return new Date().toISOString();
    };
    /**
     * @private
     * @param {LogLevel} targetLogLevel
     * @returns {boolean}
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.shouldLog = function(targetLogLevel) {
        return targetLogLevel >= this.logLevel;
    };
    /**
     * @private
     * @param {LogLevel} logLevel
     * @returns {string}
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.getLogLevelName = function(logLevel) {
        switch(logLevel){
            case $7XZb9.LogLevel.DEBUG:
                return "DEBUG";
            case $7XZb9.LogLevel.INFO:
                return "INFO ";
            case $7XZb9.LogLevel.WARNING:
                return "WARN ";
            case $7XZb9.LogLevel.ERROR:
                return "ERROR";
            default:
                return "NOTSET";
        }
    };
    /**
     * @private
     * @param {LogLevel} logLevel
     * @param {string[]} logArguments
     * @memberof ConsoleLogger
     */ ConsoleLogHandler.prototype.consoleLog = function(logLevel, logArguments) {
        switch(logLevel){
            case $7XZb9.LogLevel.DEBUG:
                console.log.apply(console, logArguments);
                break;
            case $7XZb9.LogLevel.INFO:
                console.info.apply(console, logArguments);
                break;
            case $7XZb9.LogLevel.WARNING:
                console.warn.apply(console, logArguments);
                break;
            case $7XZb9.LogLevel.ERROR:
                console.error.apply(console, logArguments);
                break;
            default:
                console.log.apply(console, logArguments);
        }
    };
    return ConsoleLogHandler;
}();
exports.ConsoleLogHandler = ConsoleLogHandler;
var globalLogLevel = $7XZb9.LogLevel.NOTSET;
var globalLogHandler = null;
var OptimizelyLogger = /** @class */ function() {
    function OptimizelyLogger(opts) {
        if (opts === void 0) opts = {};
        this.messagePrefix = "";
        if (opts.messagePrefix) this.messagePrefix = opts.messagePrefix;
    }
    /**
     * @param {(LogLevel | LogInputObject)} levelOrObj
     * @param {string} [message]
     * @memberof OptimizelyLogger
     */ OptimizelyLogger.prototype.log = function(level, message) {
        var splat = [];
        for(var _i = 2; _i < arguments.length; _i++)splat[_i - 2] = arguments[_i];
        this.internalLog(coerceLogLevel(level), {
            message: message,
            splat: splat
        });
    };
    OptimizelyLogger.prototype.info = function(message) {
        var splat = [];
        for(var _i = 1; _i < arguments.length; _i++)splat[_i - 1] = arguments[_i];
        this.namedLog($7XZb9.LogLevel.INFO, message, splat);
    };
    OptimizelyLogger.prototype.debug = function(message) {
        var splat = [];
        for(var _i = 1; _i < arguments.length; _i++)splat[_i - 1] = arguments[_i];
        this.namedLog($7XZb9.LogLevel.DEBUG, message, splat);
    };
    OptimizelyLogger.prototype.warn = function(message) {
        var splat = [];
        for(var _i = 1; _i < arguments.length; _i++)splat[_i - 1] = arguments[_i];
        this.namedLog($7XZb9.LogLevel.WARNING, message, splat);
    };
    OptimizelyLogger.prototype.error = function(message) {
        var splat = [];
        for(var _i = 1; _i < arguments.length; _i++)splat[_i - 1] = arguments[_i];
        this.namedLog($7XZb9.LogLevel.ERROR, message, splat);
    };
    OptimizelyLogger.prototype.format = function(data) {
        return "" + (this.messagePrefix ? this.messagePrefix + ": " : "") + $e1zbx.sprintf.apply(void 0, __spreadArrays([
            data.message
        ], data.splat));
    };
    OptimizelyLogger.prototype.internalLog = function(level, data) {
        if (!globalLogHandler) return;
        if (level < globalLogLevel) return;
        globalLogHandler.log(level, this.format(data));
        if (data.error && data.error instanceof Error) $b2M7F.getErrorHandler().handleError(data.error);
    };
    OptimizelyLogger.prototype.namedLog = function(level, message, splat) {
        var error;
        if (message instanceof Error) {
            error = message;
            message = error.message;
            this.internalLog(level, {
                error: error,
                message: message,
                splat: splat
            });
            return;
        }
        if (splat.length === 0) {
            this.internalLog(level, {
                message: message,
                splat: splat
            });
            return;
        }
        var last = splat[splat.length - 1];
        if (last instanceof Error) {
            error = last;
            splat.splice(-1);
        }
        this.internalLog(level, {
            message: message,
            error: error,
            splat: splat
        });
    };
    return OptimizelyLogger;
}();
var globalLogManager = new DefaultLogManager();
function getLogger(name) {
    return globalLogManager.getLogger(name);
}
exports.getLogger = getLogger;
function setLogHandler(logger) {
    globalLogHandler = logger;
}
exports.setLogHandler = setLogHandler;
function setLogLevel(level) {
    level = coerceLogLevel(level);
    if (!$e1zbx.isValidEnum($7XZb9.LogLevel, level) || level === undefined) globalLogLevel = $7XZb9.LogLevel.ERROR;
    else globalLogLevel = level;
}
exports.setLogLevel = setLogLevel;
function getLogLevel() {
    return globalLogLevel;
}
exports.getLogLevel = getLogLevel;
/**
 * Resets all global logger state to it's original
 */ function resetLogger() {
    globalLogManager = new DefaultLogManager();
    globalLogLevel = $7XZb9.LogLevel.NOTSET;
}
exports.resetLogger = resetLogger;

});
parcelRegister("e1zbx", function(module, exports) {

var $aRmx5 = parcelRequire("aRmx5");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7P6xi = parcelRequire("7P6xi");
function $a35c73b59f26c38f$var$generateUUID() {
    return $7P6xi.v4();
}
module.exports.generateUUID = $a35c73b59f26c38f$var$generateUUID;
function $a35c73b59f26c38f$var$getTimestamp() {
    return new Date().getTime();
}
module.exports.getTimestamp = $a35c73b59f26c38f$var$getTimestamp;
/**
 * Validates a value is a valid TypeScript enum
 *
 * @export
 * @param {object} enumToCheck
 * @param {*} value
 * @returns {boolean}
 */ function $a35c73b59f26c38f$var$isValidEnum(enumToCheck, value) {
    var found = false;
    var keys = Object.keys(enumToCheck);
    for(var index = 0; index < keys.length; index++)if (value === enumToCheck[keys[index]]) {
        found = true;
        break;
    }
    return found;
}
module.exports.isValidEnum = $a35c73b59f26c38f$var$isValidEnum;
function $a35c73b59f26c38f$var$groupBy(arr, grouperFn) {
    var grouper = {};
    arr.forEach(function(item) {
        var key = grouperFn(item);
        grouper[key] = grouper[key] || [];
        grouper[key].push(item);
    });
    return $a35c73b59f26c38f$var$objectValues(grouper);
}
module.exports.groupBy = $a35c73b59f26c38f$var$groupBy;
function $a35c73b59f26c38f$var$objectValues(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
}
module.exports.objectValues = $a35c73b59f26c38f$var$objectValues;
function $a35c73b59f26c38f$var$objectEntries(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
}
module.exports.objectEntries = $a35c73b59f26c38f$var$objectEntries;
function $a35c73b59f26c38f$var$find(arr, cond) {
    var found;
    for(var _i = 0, arr_1 = arr; _i < arr_1.length; _i++){
        var item = arr_1[_i];
        if (cond(item)) {
            found = item;
            break;
        }
    }
    return found;
}
module.exports.find = $a35c73b59f26c38f$var$find;
function $a35c73b59f26c38f$var$keyBy(arr, keyByFn) {
    var map = {};
    arr.forEach(function(item) {
        var key = keyByFn(item);
        map[key] = item;
    });
    return map;
}
module.exports.keyBy = $a35c73b59f26c38f$var$keyBy;
function $a35c73b59f26c38f$var$sprintf(format) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var i = 0;
    return format.replace(/%s/g, function() {
        var arg = args[i++];
        var type = typeof arg === "undefined" ? "undefined" : (0, $aRmx5._)(arg);
        if (type === "function") return arg();
        else if (type === "string") return arg;
        else return String(arg);
    });
}
module.exports.sprintf = $a35c73b59f26c38f$var$sprintf;
/*
 * Notification types for use with NotificationCenter
 * Format is EVENT: <list of parameters to callback>
 *
 * SDK consumers can use these to register callbacks with the notification center.
 *
 *  @deprecated since 3.1.0
 *  ACTIVATE: An impression event will be sent to Optimizely
 *  Callbacks will receive an object argument with the following properties:
 *    - experiment {Object}
 *    - userId {string}
 *    - attributes {Object|undefined}
 *    - variation {Object}
 *    - logEvent {Object}
 *
 *  DECISION: A decision is made in the system. i.e. user activation,
 *  feature access or feature-variable value retrieval
 *  Callbacks will receive an object argument with the following properties:
 *    - type {string}
 *    - userId {string}
 *    - attributes {Object|undefined}
 *    - decisionInfo {Object|undefined}
 *
 *  LOG_EVENT: A batch of events, which could contain impressions and/or conversions,
 *  will be sent to Optimizely
 *  Callbacks will receive an object argument with the following properties:
 *    - url {string}
 *    - httpVerb {string}
 *    - params {Object}
 *
 *  OPTIMIZELY_CONFIG_UPDATE: This Optimizely instance has been updated with a new
 *  config
 *
 *  TRACK: A conversion event will be sent to Optimizely
 *  Callbacks will receive the an object argument with the following properties:
 *    - eventKey {string}
 *    - userId {string}
 *    - attributes {Object|undefined}
 *    - eventTags {Object|undefined}
 *    - logEvent {Object}
 *
 */ var $a35c73b59f26c38f$var$NOTIFICATION_TYPES;
(function(NOTIFICATION_TYPES) {
    NOTIFICATION_TYPES["ACTIVATE"] = "ACTIVATE:experiment, user_id,attributes, variation, event";
    NOTIFICATION_TYPES["DECISION"] = "DECISION:type, userId, attributes, decisionInfo";
    NOTIFICATION_TYPES["LOG_EVENT"] = "LOG_EVENT:logEvent";
    NOTIFICATION_TYPES["OPTIMIZELY_CONFIG_UPDATE"] = "OPTIMIZELY_CONFIG_UPDATE";
    NOTIFICATION_TYPES["TRACK"] = "TRACK:event_key, user_id, attributes, event_tags, event";
})($a35c73b59f26c38f$var$NOTIFICATION_TYPES = module.exports.NOTIFICATION_TYPES || (module.exports.NOTIFICATION_TYPES = {}));

});
parcelRegister("7P6xi", function(module, exports) {

var $9ghnH = parcelRequire("9ghnH");

var $2D8FD = parcelRequire("2D8FD");
var $5b225dbb734df953$var$uuid = $2D8FD;
$5b225dbb734df953$var$uuid.v1 = $9ghnH;
$5b225dbb734df953$var$uuid.v4 = $2D8FD;
module.exports = $5b225dbb734df953$var$uuid;

});
parcelRegister("9ghnH", function(module, exports) {

var $gPvPF = parcelRequire("gPvPF");

var $lUtOT = parcelRequire("lUtOT");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $6be31737d322ea74$var$_nodeId;
var $6be31737d322ea74$var$_clockseq;
// Previous uuid creation time
var $6be31737d322ea74$var$_lastMSecs = 0;
var $6be31737d322ea74$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $6be31737d322ea74$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $6be31737d322ea74$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $6be31737d322ea74$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $gPvPF();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $6be31737d322ea74$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $6be31737d322ea74$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $6be31737d322ea74$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $6be31737d322ea74$var$_lastMSecs + (nsecs - $6be31737d322ea74$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $6be31737d322ea74$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $6be31737d322ea74$var$_lastMSecs = msecs;
    $6be31737d322ea74$var$_lastNSecs = nsecs;
    $6be31737d322ea74$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lUtOT(b);
}
module.exports = $6be31737d322ea74$var$v1;

});
parcelRegister("gPvPF", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $c40a19fad2008d57$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($c40a19fad2008d57$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $c40a19fad2008d57$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $c40a19fad2008d57$var$getRandomValues($c40a19fad2008d57$var$rnds8);
        return $c40a19fad2008d57$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $c40a19fad2008d57$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $c40a19fad2008d57$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $c40a19fad2008d57$var$rnds;
    };
}

});

parcelRegister("lUtOT", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $ff35f58b053fad10$var$byteToHex = [];
for(var $ff35f58b053fad10$var$i = 0; $ff35f58b053fad10$var$i < 256; ++$ff35f58b053fad10$var$i)$ff35f58b053fad10$var$byteToHex[$ff35f58b053fad10$var$i] = ($ff35f58b053fad10$var$i + 0x100).toString(16).substr(1);
function $ff35f58b053fad10$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $ff35f58b053fad10$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $ff35f58b053fad10$var$bytesToUuid;

});


parcelRegister("2D8FD", function(module, exports) {

var $gPvPF = parcelRequire("gPvPF");

var $lUtOT = parcelRequire("lUtOT");
function $1ea5f311c6ad84cc$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $gPvPF)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lUtOT(rnds);
}
module.exports = $1ea5f311c6ad84cc$var$v4;

});





parcelRegister("l1o0O", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f4dc51438ab234c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4dc51438ab234c6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4dc51438ab234c6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4dc51438ab234c6$var$__exportStar((parcelRequire("hB3VV")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("7Q5Dj")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("3clat")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("1onDb")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("lJzrX")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("12Li0")), module.exports);

$f4dc51438ab234c6$var$__exportStar((parcelRequire("iK1JM")), module.exports);

});
parcelRegister("hB3VV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.areEventContextsEqual = void 0;
function $ccf8f175da5cc65b$var$areEventContextsEqual(eventA, eventB) {
    var contextA = eventA.context;
    var contextB = eventB.context;
    return contextA.accountId === contextB.accountId && contextA.projectId === contextB.projectId && contextA.clientName === contextB.clientName && contextA.clientVersion === contextB.clientVersion && contextA.revision === contextB.revision && contextA.anonymizeIP === contextB.anonymizeIP && contextA.botFiltering === contextB.botFiltering;
}
module.exports.areEventContextsEqual = $ccf8f175da5cc65b$var$areEventContextsEqual;

});

parcelRegister("7Q5Dj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendEventNotification = module.exports.getQueue = module.exports.validateAndGetBatchSize = module.exports.validateAndGetFlushInterval = module.exports.DEFAULT_BATCH_SIZE = module.exports.DEFAULT_FLUSH_INTERVAL = void 0;

var $d8AqV = parcelRequire("d8AqV");

var $8NKT3 = parcelRequire("8NKT3");

var $e1zbx = parcelRequire("e1zbx");
module.exports.DEFAULT_FLUSH_INTERVAL = 30000; // Unit is ms - default flush interval is 30s
module.exports.DEFAULT_BATCH_SIZE = 10;
var $5b51c25b7291b476$var$logger = $8NKT3.getLogger("EventProcessor");
function $5b51c25b7291b476$var$validateAndGetFlushInterval(flushInterval) {
    if (flushInterval <= 0) {
        $5b51c25b7291b476$var$logger.warn("Invalid flushInterval " + flushInterval + ", defaulting to " + module.exports.DEFAULT_FLUSH_INTERVAL);
        flushInterval = module.exports.DEFAULT_FLUSH_INTERVAL;
    }
    return flushInterval;
}
module.exports.validateAndGetFlushInterval = $5b51c25b7291b476$var$validateAndGetFlushInterval;
function $5b51c25b7291b476$var$validateAndGetBatchSize(batchSize) {
    batchSize = Math.floor(batchSize);
    if (batchSize < 1) {
        $5b51c25b7291b476$var$logger.warn("Invalid batchSize " + batchSize + ", defaulting to " + module.exports.DEFAULT_BATCH_SIZE);
        batchSize = module.exports.DEFAULT_BATCH_SIZE;
    }
    batchSize = Math.max(1, batchSize);
    return batchSize;
}
module.exports.validateAndGetBatchSize = $5b51c25b7291b476$var$validateAndGetBatchSize;
function $5b51c25b7291b476$var$getQueue(batchSize, flushInterval, batchComparator, sink, closingSink) {
    var queue;
    if (batchSize > 1) queue = new $d8AqV.DefaultEventQueue({
        flushInterval: flushInterval,
        maxQueueSize: batchSize,
        batchComparator: batchComparator,
        sink: sink,
        closingSink: closingSink
    });
    else queue = new $d8AqV.SingleEventQueue({
        sink: sink
    });
    return queue;
}
module.exports.getQueue = $5b51c25b7291b476$var$getQueue;
function $5b51c25b7291b476$var$sendEventNotification(notificationCenter, event) {
    if (notificationCenter) notificationCenter.sendNotifications($e1zbx.NOTIFICATION_TYPES.LOG_EVENT, event);
}
module.exports.sendEventNotification = $5b51c25b7291b476$var$sendEventNotification;

});
parcelRegister("d8AqV", function(module, exports) {
"use strict";
/**
 * Copyright 2019, 2023 Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEventQueue = module.exports.SingleEventQueue = void 0;

var $8NKT3 = parcelRequire("8NKT3");
var $9908489e6c6a2b48$var$logger = $8NKT3.getLogger("EventProcessor");
var $9908489e6c6a2b48$var$Timer = /** @class */ function() {
    function Timer(_a) {
        var timeout = _a.timeout, callback = _a.callback;
        this.timeout = Math.max(timeout, 0);
        this.callback = callback;
    }
    Timer.prototype.start = function() {
        this.timeoutId = setTimeout(this.callback, this.timeout);
    };
    Timer.prototype.refresh = function() {
        this.stop();
        this.start();
    };
    Timer.prototype.stop = function() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    };
    return Timer;
}();
var $9908489e6c6a2b48$var$SingleEventQueue = /** @class */ function() {
    function SingleEventQueue(_a) {
        var sink = _a.sink;
        this.sink = sink;
    }
    SingleEventQueue.prototype.start = function() {
    // no-op
    };
    SingleEventQueue.prototype.stop = function() {
        // no-op
        return Promise.resolve();
    };
    SingleEventQueue.prototype.enqueue = function(event) {
        this.sink([
            event
        ]);
    };
    return SingleEventQueue;
}();
module.exports.SingleEventQueue = $9908489e6c6a2b48$var$SingleEventQueue;
var $9908489e6c6a2b48$var$DefaultEventQueue = /** @class */ function() {
    function DefaultEventQueue(_a) {
        var flushInterval = _a.flushInterval, maxQueueSize = _a.maxQueueSize, sink = _a.sink, closingSink = _a.closingSink, batchComparator = _a.batchComparator;
        this.buffer = [];
        this.maxQueueSize = Math.max(maxQueueSize, 1);
        this.sink = sink;
        this.closingSink = closingSink;
        this.batchComparator = batchComparator;
        this.timer = new $9908489e6c6a2b48$var$Timer({
            callback: this.flush.bind(this),
            timeout: flushInterval
        });
        this.started = false;
    }
    DefaultEventQueue.prototype.start = function() {
        this.started = true;
    // dont start the timer until the first event is enqueued
    };
    DefaultEventQueue.prototype.stop = function() {
        this.started = false;
        var result = this.closingSink ? this.closingSink(this.buffer) : this.sink(this.buffer);
        this.buffer = [];
        this.timer.stop();
        return result;
    };
    DefaultEventQueue.prototype.enqueue = function(event) {
        if (!this.started) {
            $9908489e6c6a2b48$var$logger.warn("Queue is stopped, not accepting event");
            return;
        }
        // If new event cannot be included into the current batch, flush so it can
        // be in its own new batch.
        var bufferedEvent = this.buffer[0];
        if (bufferedEvent && !this.batchComparator(bufferedEvent, event)) this.flush();
        // start the timer when the first event is put in
        if (this.buffer.length === 0) this.timer.refresh();
        this.buffer.push(event);
        if (this.buffer.length >= this.maxQueueSize) this.flush();
    };
    DefaultEventQueue.prototype.flush = function() {
        this.sink(this.buffer);
        this.buffer = [];
        this.timer.stop();
    };
    return DefaultEventQueue;
}();
module.exports.DefaultEventQueue = $9908489e6c6a2b48$var$DefaultEventQueue;

});


parcelRegister("3clat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1onDb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lJzrX", function(module, exports) {
"use strict";
var $fd294c89629d9832$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalStoragePendingEventsDispatcher = module.exports.PendingEventsDispatcher = void 0;

var $8NKT3 = parcelRequire("8NKT3");

var $bzYBZ = parcelRequire("bzYBZ");

var $e1zbx = parcelRequire("e1zbx");
var $fd294c89629d9832$var$logger = $8NKT3.getLogger("EventProcessor");
var $fd294c89629d9832$var$PendingEventsDispatcher = /** @class */ function() {
    function PendingEventsDispatcher(_a) {
        var eventDispatcher = _a.eventDispatcher, store = _a.store;
        this.dispatcher = eventDispatcher;
        this.store = store;
    }
    PendingEventsDispatcher.prototype.dispatchEvent = function(request, callback) {
        this.send({
            uuid: $e1zbx.generateUUID(),
            timestamp: $e1zbx.getTimestamp(),
            request: request
        }, callback);
    };
    PendingEventsDispatcher.prototype.sendPendingEvents = function() {
        var _this = this;
        var pendingEvents = this.store.values();
        $fd294c89629d9832$var$logger.debug("Sending %s pending events from previous page", pendingEvents.length);
        pendingEvents.forEach(function(item) {
            try {
                _this.send(item, function() {});
            } catch (e) {}
        });
    };
    PendingEventsDispatcher.prototype.send = function(entry, callback) {
        var _this = this;
        this.store.set(entry.uuid, entry);
        this.dispatcher.dispatchEvent(entry.request, function(response) {
            _this.store.remove(entry.uuid);
            callback(response);
        });
    };
    return PendingEventsDispatcher;
}();
module.exports.PendingEventsDispatcher = $fd294c89629d9832$var$PendingEventsDispatcher;
var $fd294c89629d9832$var$LocalStoragePendingEventsDispatcher = /** @class */ function(_super) {
    $fd294c89629d9832$var$__extends(LocalStoragePendingEventsDispatcher, _super);
    function LocalStoragePendingEventsDispatcher(_a) {
        var eventDispatcher = _a.eventDispatcher;
        return _super.call(this, {
            eventDispatcher: eventDispatcher,
            store: new $bzYBZ.LocalStorageStore({
                // TODO make this configurable
                maxValues: 100,
                key: "fs_optly_pending_events"
            })
        }) || this;
    }
    return LocalStoragePendingEventsDispatcher;
}($fd294c89629d9832$var$PendingEventsDispatcher);
module.exports.LocalStoragePendingEventsDispatcher = $fd294c89629d9832$var$LocalStoragePendingEventsDispatcher;

});
parcelRegister("bzYBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalStorageStore = void 0;

var $e1zbx = parcelRequire("e1zbx");

var $8NKT3 = parcelRequire("8NKT3");
var $86e1facf160e9c97$var$logger = $8NKT3.getLogger("EventProcessor");
var $86e1facf160e9c97$var$LocalStorageStore = /** @class */ function() {
    function LocalStorageStore(_a) {
        var key = _a.key, _b = _a.maxValues, maxValues = _b === void 0 ? 1000 : _b;
        this.LS_KEY = key;
        this.maxValues = maxValues;
    }
    LocalStorageStore.prototype.get = function(key) {
        return this.getMap()[key] || null;
    };
    LocalStorageStore.prototype.set = function(key, value) {
        var map = this.getMap();
        map[key] = value;
        this.replace(map);
    };
    LocalStorageStore.prototype.remove = function(key) {
        var map = this.getMap();
        delete map[key];
        this.replace(map);
    };
    LocalStorageStore.prototype.values = function() {
        return $e1zbx.objectValues(this.getMap());
    };
    LocalStorageStore.prototype.clear = function() {
        this.replace({});
    };
    LocalStorageStore.prototype.replace = function(map) {
        try {
            // This is a temporary fix to support React Native which does not have localStorage.
            window.localStorage && localStorage.setItem(this.LS_KEY, JSON.stringify(map));
            this.clean();
        } catch (e) {
            $86e1facf160e9c97$var$logger.error(e);
        }
    };
    LocalStorageStore.prototype.clean = function() {
        var map = this.getMap();
        var keys = Object.keys(map);
        var toRemove = keys.length - this.maxValues;
        if (toRemove < 1) return;
        var entries = keys.map(function(key) {
            return {
                key: key,
                value: map[key]
            };
        });
        entries.sort(function(a, b) {
            return a.value.timestamp - b.value.timestamp;
        });
        for(var i = 0; i < toRemove; i++)delete map[entries[i].key];
        this.replace(map);
    };
    LocalStorageStore.prototype.getMap = function() {
        try {
            // This is a temporary fix to support React Native which does not have localStorage.
            var data = window.localStorage && localStorage.getItem(this.LS_KEY);
            if (data) return JSON.parse(data) || {};
        } catch (e) {
            $86e1facf160e9c97$var$logger.error(e);
        }
        return {};
    };
    return LocalStorageStore;
}();
module.exports.LocalStorageStore = $86e1facf160e9c97$var$LocalStorageStore;

});


parcelRegister("12Li0", function(module, exports) {
"use strict";
var $0c2aa904a7ac47d6$var$__assign = module.exports && module.exports.__assign || function() {
    $0c2aa904a7ac47d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c2aa904a7ac47d6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatEvents = module.exports.buildConversionEventV1 = module.exports.buildImpressionEventV1 = module.exports.makeBatchedEventV1 = void 0;
var $0c2aa904a7ac47d6$var$ACTIVATE_EVENT_KEY = "campaign_activated";
var $0c2aa904a7ac47d6$var$CUSTOM_ATTRIBUTE_FEATURE_TYPE = "custom";
var $0c2aa904a7ac47d6$var$BOT_FILTERING_KEY = "$opt_bot_filtering";
/**
 * Given an array of batchable Decision or ConversionEvent events it returns
 * a single EventV1 with proper batching
 *
 * @param {ProcessableEvent[]} events
 * @returns {EventV1}
 */ function $0c2aa904a7ac47d6$var$makeBatchedEventV1(events) {
    var visitors = [];
    var data = events[0];
    events.forEach(function(event) {
        if (event.type === "conversion" || event.type === "impression") {
            var visitor = $0c2aa904a7ac47d6$var$makeVisitor(event);
            if (event.type === "impression") visitor.snapshots.push($0c2aa904a7ac47d6$var$makeDecisionSnapshot(event));
            else if (event.type === "conversion") visitor.snapshots.push($0c2aa904a7ac47d6$var$makeConversionSnapshot(event));
            visitors.push(visitor);
        }
    });
    return {
        client_name: data.context.clientName,
        client_version: data.context.clientVersion,
        account_id: data.context.accountId,
        project_id: data.context.projectId,
        revision: data.context.revision,
        anonymize_ip: data.context.anonymizeIP,
        enrich_decisions: true,
        visitors: visitors
    };
}
module.exports.makeBatchedEventV1 = $0c2aa904a7ac47d6$var$makeBatchedEventV1;
function $0c2aa904a7ac47d6$var$makeConversionSnapshot(conversion) {
    var tags = $0c2aa904a7ac47d6$var$__assign({}, conversion.tags);
    delete tags["revenue"];
    delete tags["value"];
    var event = {
        entity_id: conversion.event.id,
        key: conversion.event.key,
        timestamp: conversion.timestamp,
        uuid: conversion.uuid
    };
    if (conversion.tags) event.tags = conversion.tags;
    if (conversion.value != null) event.value = conversion.value;
    if (conversion.revenue != null) event.revenue = conversion.revenue;
    return {
        events: [
            event
        ]
    };
}
function $0c2aa904a7ac47d6$var$makeDecisionSnapshot(event) {
    var _a, _b;
    var layer = event.layer, experiment = event.experiment, variation = event.variation, ruleKey = event.ruleKey, flagKey = event.flagKey, ruleType = event.ruleType, enabled = event.enabled;
    var layerId = layer ? layer.id : null;
    var experimentId = (_a = experiment === null || experiment === void 0 ? void 0 : experiment.id) !== null && _a !== void 0 ? _a : "";
    var variationId = (_b = variation === null || variation === void 0 ? void 0 : variation.id) !== null && _b !== void 0 ? _b : "";
    var variationKey = variation ? variation.key : "";
    return {
        decisions: [
            {
                campaign_id: layerId,
                experiment_id: experimentId,
                variation_id: variationId,
                metadata: {
                    flag_key: flagKey,
                    rule_key: ruleKey,
                    rule_type: ruleType,
                    variation_key: variationKey,
                    enabled: enabled
                }
            }
        ],
        events: [
            {
                entity_id: layerId,
                timestamp: event.timestamp,
                key: $0c2aa904a7ac47d6$var$ACTIVATE_EVENT_KEY,
                uuid: event.uuid
            }
        ]
    };
}
function $0c2aa904a7ac47d6$var$makeVisitor(data) {
    var visitor = {
        snapshots: [],
        visitor_id: data.user.id,
        attributes: []
    };
    data.user.attributes.forEach(function(attr) {
        visitor.attributes.push({
            entity_id: attr.entityId,
            key: attr.key,
            type: "custom",
            value: attr.value
        });
    });
    if (typeof data.context.botFiltering === "boolean") visitor.attributes.push({
        entity_id: $0c2aa904a7ac47d6$var$BOT_FILTERING_KEY,
        key: $0c2aa904a7ac47d6$var$BOT_FILTERING_KEY,
        type: $0c2aa904a7ac47d6$var$CUSTOM_ATTRIBUTE_FEATURE_TYPE,
        value: data.context.botFiltering
    });
    return visitor;
}
/**
 * Event for usage with v1 logtier
 *
 * @export
 * @interface EventBuilderV1
 */ function $0c2aa904a7ac47d6$var$buildImpressionEventV1(data) {
    var visitor = $0c2aa904a7ac47d6$var$makeVisitor(data);
    visitor.snapshots.push($0c2aa904a7ac47d6$var$makeDecisionSnapshot(data));
    return {
        client_name: data.context.clientName,
        client_version: data.context.clientVersion,
        account_id: data.context.accountId,
        project_id: data.context.projectId,
        revision: data.context.revision,
        anonymize_ip: data.context.anonymizeIP,
        enrich_decisions: true,
        visitors: [
            visitor
        ]
    };
}
module.exports.buildImpressionEventV1 = $0c2aa904a7ac47d6$var$buildImpressionEventV1;
function $0c2aa904a7ac47d6$var$buildConversionEventV1(data) {
    var visitor = $0c2aa904a7ac47d6$var$makeVisitor(data);
    visitor.snapshots.push($0c2aa904a7ac47d6$var$makeConversionSnapshot(data));
    return {
        client_name: data.context.clientName,
        client_version: data.context.clientVersion,
        account_id: data.context.accountId,
        project_id: data.context.projectId,
        revision: data.context.revision,
        anonymize_ip: data.context.anonymizeIP,
        enrich_decisions: true,
        visitors: [
            visitor
        ]
    };
}
module.exports.buildConversionEventV1 = $0c2aa904a7ac47d6$var$buildConversionEventV1;
function $0c2aa904a7ac47d6$var$formatEvents(events) {
    return {
        url: "https://logx.optimizely.com/v1/events",
        httpVerb: "POST",
        params: $0c2aa904a7ac47d6$var$makeBatchedEventV1(events)
    };
}
module.exports.formatEvents = $0c2aa904a7ac47d6$var$formatEvents;

});

parcelRegister("iK1JM", function(module, exports) {
"use strict";
var $da4ddee03e4b3128$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $da4ddee03e4b3128$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $da4ddee03e4b3128$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogTierV1EventProcessor = void 0;

var $8NKT3 = parcelRequire("8NKT3");

var $7Q5Dj = parcelRequire("7Q5Dj");

var $da4ddee03e4b3128$var$requestTracker_1 = $da4ddee03e4b3128$var$__importDefault((parcelRequire("4HumS")));

var $hB3VV = parcelRequire("hB3VV");

var $12Li0 = parcelRequire("12Li0");
var $da4ddee03e4b3128$var$logger = $8NKT3.getLogger("LogTierV1EventProcessor");
var $da4ddee03e4b3128$var$LogTierV1EventProcessor = /** @class */ function() {
    function LogTierV1EventProcessor(_a) {
        var dispatcher = _a.dispatcher, closingDispatcher = _a.closingDispatcher, _b = _a.flushInterval, flushInterval = _b === void 0 ? $7Q5Dj.DEFAULT_FLUSH_INTERVAL : _b, _c = _a.batchSize, batchSize = _c === void 0 ? $7Q5Dj.DEFAULT_BATCH_SIZE : _c, notificationCenter = _a.notificationCenter;
        this.dispatcher = dispatcher;
        this.closingDispatcher = closingDispatcher;
        this.notificationCenter = notificationCenter;
        this.requestTracker = new $da4ddee03e4b3128$var$requestTracker_1.default();
        flushInterval = $7Q5Dj.validateAndGetFlushInterval(flushInterval);
        batchSize = $7Q5Dj.validateAndGetBatchSize(batchSize);
        this.queue = $7Q5Dj.getQueue(batchSize, flushInterval, $hB3VV.areEventContextsEqual, this.drainQueue.bind(this, false), this.drainQueue.bind(this, true));
    }
    LogTierV1EventProcessor.prototype.drainQueue = function(useClosingDispatcher, buffer) {
        var _this = this;
        var reqPromise = new Promise(function(resolve) {
            $da4ddee03e4b3128$var$logger.debug("draining queue with %s events", buffer.length);
            if (buffer.length === 0) {
                resolve();
                return;
            }
            var formattedEvent = $12Li0.formatEvents(buffer);
            var dispatcher = useClosingDispatcher && _this.closingDispatcher ? _this.closingDispatcher : _this.dispatcher;
            dispatcher.dispatchEvent(formattedEvent, function() {
                resolve();
            });
            $7Q5Dj.sendEventNotification(_this.notificationCenter, formattedEvent);
        });
        this.requestTracker.trackRequest(reqPromise);
        return reqPromise;
    };
    LogTierV1EventProcessor.prototype.process = function(event) {
        this.queue.enqueue(event);
    };
    LogTierV1EventProcessor.prototype.stop = function() {
        // swallow - an error stopping this queue shouldn't prevent this from stopping
        try {
            this.queue.stop();
            return this.requestTracker.onRequestsComplete();
        } catch (e) {
            $da4ddee03e4b3128$var$logger.error('Error stopping EventProcessor: "%s"', e.message, e);
        }
        return Promise.resolve();
    };
    LogTierV1EventProcessor.prototype.start = function() {
        return $da4ddee03e4b3128$var$__awaiter(this, void 0, void 0, function() {
            return $da4ddee03e4b3128$var$__generator(this, function(_a) {
                this.queue.start();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return LogTierV1EventProcessor;
}();
module.exports.LogTierV1EventProcessor = $da4ddee03e4b3128$var$LogTierV1EventProcessor;

});
parcelRegister("4HumS", function(module, exports) {
"use strict";
/**
 * Copyright 2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * RequestTracker keeps track of in-flight requests for EventProcessor using
 * an internal counter. It exposes methods for adding a new request to be
 * tracked, and getting a Promise representing the completion of currently
 * tracked requests.
 */ var $36c2bc030baf1405$var$RequestTracker = /** @class */ function() {
    function RequestTracker() {
        this.reqsInFlightCount = 0;
        this.reqsCompleteResolvers = [];
    }
    /**
     * Track the argument request (represented by a Promise). reqPromise will feed
     * into the state of Promises returned by onRequestsComplete.
     * @param {Promise<void>} reqPromise
     */ RequestTracker.prototype.trackRequest = function(reqPromise) {
        var _this = this;
        this.reqsInFlightCount++;
        var onReqComplete = function onReqComplete() {
            _this.reqsInFlightCount--;
            if (_this.reqsInFlightCount === 0) {
                _this.reqsCompleteResolvers.forEach(function(resolver) {
                    return resolver();
                });
                _this.reqsCompleteResolvers = [];
            }
        };
        reqPromise.then(onReqComplete, onReqComplete);
    };
    /**
     * Return a Promise that fulfills after all currently-tracked request promises
     * are resolved.
     * @return {Promise<void>}
     */ RequestTracker.prototype.onRequestsComplete = function() {
        var _this = this;
        return new Promise(function(resolve) {
            if (_this.reqsInFlightCount === 0) resolve();
            else _this.reqsCompleteResolvers.push(resolve);
        });
    };
    return RequestTracker;
}();
module.exports.default = $36c2bc030baf1405$var$RequestTracker;

});



parcelRegister("2YySW", function(module, exports) {
(function() {
    var _global = this;
    /**
   * JS Implementation of MurmurHash2
   *
   * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
   * @see http://github.com/garycourt/murmurhash-js
   * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
   * @see http://sites.google.com/site/murmurhash/
   *
   * @param {string} str ASCII only
   * @param {number} seed Positive integer only
   * @return {number} 32-bit positive integer hash
   */ function MurmurHashV2(str, seed) {
        var l = str.length, h = seed ^ l, i = 0, k;
        while(l >= 4){
            k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            k ^= k >>> 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
            l -= 4;
            ++i;
        }
        switch(l){
            case 3:
                h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                h ^= str.charCodeAt(i) & 0xff;
                h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        }
        h ^= h >>> 13;
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h ^= h >>> 15;
        return h >>> 0;
    }
    /**
   * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
   *
   * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
   * @see http://github.com/garycourt/murmurhash-js
   * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
   * @see http://sites.google.com/site/murmurhash/
   *
   * @param {string} key ASCII only
   * @param {number} seed Positive integer only
   * @return {number} 32-bit positive integer hash
   */ function MurmurHashV3(key, seed) {
        var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
        remainder = key.length & 3; // key.length % 4
        bytes = key.length - remainder;
        h1 = seed;
        c1 = 0xcc9e2d51;
        c2 = 0x1b873593;
        i = 0;
        while(i < bytes){
            k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(++i) & 0xff) << 8 | (key.charCodeAt(++i) & 0xff) << 16 | (key.charCodeAt(++i) & 0xff) << 24;
            ++i;
            k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1b = (h1 & 0xffff) * 5 + (((h1 >>> 16) * 5 & 0xffff) << 16) & 0xffffffff;
            h1 = (h1b & 0xffff) + 0x6b64 + (((h1b >>> 16) + 0xe654 & 0xffff) << 16);
        }
        k1 = 0;
        switch(remainder){
            case 3:
                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                k1 ^= key.charCodeAt(i) & 0xff;
                k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
                h1 ^= k1;
        }
        h1 ^= key.length;
        h1 ^= h1 >>> 16;
        h1 = (h1 & 0xffff) * 0x85ebca6b + (((h1 >>> 16) * 0x85ebca6b & 0xffff) << 16) & 0xffffffff;
        h1 ^= h1 >>> 13;
        h1 = (h1 & 0xffff) * 0xc2b2ae35 + (((h1 >>> 16) * 0xc2b2ae35 & 0xffff) << 16) & 0xffffffff;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
    }
    var murmur = MurmurHashV3;
    murmur.v2 = MurmurHashV2;
    murmur.v3 = MurmurHashV3;
    if (typeof module != "undefined") module.exports = murmur;
    else {
        var _previousRoot = _global.murmur;
        murmur.noConflict = function() {
            _global.murmur = _previousRoot;
            return murmur;
        };
        _global.murmur = murmur;
    }
})();

});

parcelRegister("5lUdl", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9bmgX = parcelRequire("9bmgX");
module.exports.HttpPollingDatafileManager = $9bmgX.default;

});
parcelRegister("9bmgX", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6af66b010da84a86$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6af66b010da84a86$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jeLyH = parcelRequire("jeLyH");

var $6af66b010da84a86$var$httpPollingDatafileManager_1 = $6af66b010da84a86$var$__importDefault((parcelRequire("9snHj")));
var $6af66b010da84a86$var$BrowserDatafileManager = /** @class */ function(_super) {
    $6af66b010da84a86$var$__extends(BrowserDatafileManager, _super);
    function BrowserDatafileManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserDatafileManager.prototype.makeGetRequest = function(reqUrl, headers) {
        return $jeLyH.makeGetRequest(reqUrl, headers);
    };
    BrowserDatafileManager.prototype.getConfigDefaults = function() {
        return {
            autoUpdate: false
        };
    };
    return BrowserDatafileManager;
}($6af66b010da84a86$var$httpPollingDatafileManager_1.default);
module.exports.default = $6af66b010da84a86$var$BrowserDatafileManager;

});
parcelRegister("jeLyH", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eBKYi = parcelRequire("eBKYi");

var $8NKT3 = parcelRequire("8NKT3");
var $e014374dd9a672e2$var$logger = $8NKT3.getLogger("DatafileManager");
var $e014374dd9a672e2$var$GET_METHOD = "GET";
var $e014374dd9a672e2$var$READY_STATE_DONE = 4;
function $e014374dd9a672e2$var$parseHeadersFromXhr(req) {
    var allHeadersString = req.getAllResponseHeaders();
    if (allHeadersString === null) return {};
    var headerLines = allHeadersString.split("\r\n");
    var headers = {};
    headerLines.forEach(function(headerLine) {
        var separatorIndex = headerLine.indexOf(": ");
        if (separatorIndex > -1) {
            var headerName = headerLine.slice(0, separatorIndex);
            var headerValue = headerLine.slice(separatorIndex + 2);
            if (headerValue.length > 0) headers[headerName] = headerValue;
        }
    });
    return headers;
}
function $e014374dd9a672e2$var$setHeadersInXhr(headers, req) {
    Object.keys(headers).forEach(function(headerName) {
        var header = headers[headerName];
        req.setRequestHeader(headerName, header);
    });
}
function $e014374dd9a672e2$var$makeGetRequest(reqUrl, headers) {
    var req = new XMLHttpRequest();
    var responsePromise = new Promise(function(resolve, reject) {
        req.open($e014374dd9a672e2$var$GET_METHOD, reqUrl, true);
        $e014374dd9a672e2$var$setHeadersInXhr(headers, req);
        req.onreadystatechange = function() {
            if (req.readyState === $e014374dd9a672e2$var$READY_STATE_DONE) {
                var statusCode = req.status;
                if (statusCode === 0) {
                    reject(new Error("Request error"));
                    return;
                }
                var headers_1 = $e014374dd9a672e2$var$parseHeadersFromXhr(req);
                var resp = {
                    statusCode: req.status,
                    body: req.responseText,
                    headers: headers_1
                };
                resolve(resp);
            }
        };
        req.timeout = $eBKYi.REQUEST_TIMEOUT_MS;
        req.ontimeout = function() {
            $e014374dd9a672e2$var$logger.error("Request timed out");
        };
        req.send();
    });
    return {
        responsePromise: responsePromise,
        abort: function abort() {
            req.abort();
        }
    };
}
module.exports.makeGetRequest = $e014374dd9a672e2$var$makeGetRequest;

});
parcelRegister("eBKYi", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_UPDATE_INTERVAL = 300000; // 5 minutes
module.exports.MIN_UPDATE_INTERVAL = 1000;
module.exports.DEFAULT_URL_TEMPLATE = "https://cdn.optimizely.com/datafiles/%s.json";
module.exports.DEFAULT_AUTHENTICATED_URL_TEMPLATE = "https://config.optimizely.com/datafiles/auth/%s.json";
module.exports.BACKOFF_BASE_WAIT_SECONDS_BY_ERROR_COUNT = [
    0,
    8,
    16,
    32,
    64,
    128,
    256,
    512
];
module.exports.REQUEST_TIMEOUT_MS = 60000; // 1 minute

});


parcelRegister("9snHj", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6e291c69f8e72436$var$__assign = module.exports && module.exports.__assign || function() {
    $6e291c69f8e72436$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e291c69f8e72436$var$__assign.apply(this, arguments);
};
var $6e291c69f8e72436$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8NKT3 = parcelRequire("8NKT3");

var $e1zbx = parcelRequire("e1zbx");

var $6e291c69f8e72436$var$eventEmitter_1 = $6e291c69f8e72436$var$__importDefault((parcelRequire("1J7cm")));

var $eBKYi = parcelRequire("eBKYi");

var $6e291c69f8e72436$var$backoffController_1 = $6e291c69f8e72436$var$__importDefault((parcelRequire("lcyoc")));
var $6e291c69f8e72436$var$logger = $8NKT3.getLogger("DatafileManager");
var $6e291c69f8e72436$var$UPDATE_EVT = "update";
function $6e291c69f8e72436$var$isValidUpdateInterval(updateInterval) {
    return updateInterval >= $eBKYi.MIN_UPDATE_INTERVAL;
}
function $6e291c69f8e72436$var$isSuccessStatusCode(statusCode) {
    return statusCode >= 200 && statusCode < 400;
}
var $6e291c69f8e72436$var$noOpKeyValueCache = {
    get: function get() {
        return Promise.resolve("");
    },
    set: function set() {
        return Promise.resolve();
    },
    contains: function contains() {
        return Promise.resolve(false);
    },
    remove: function remove() {
        return Promise.resolve();
    }
};
var $6e291c69f8e72436$var$HttpPollingDatafileManager = /** @class */ function() {
    function HttpPollingDatafileManager(config) {
        var _this = this;
        var configWithDefaultsApplied = $6e291c69f8e72436$var$__assign($6e291c69f8e72436$var$__assign({}, this.getConfigDefaults()), config);
        var datafile = configWithDefaultsApplied.datafile, _a = configWithDefaultsApplied.autoUpdate, autoUpdate = _a === void 0 ? false : _a, sdkKey = configWithDefaultsApplied.sdkKey, _b = configWithDefaultsApplied.updateInterval, updateInterval = _b === void 0 ? $eBKYi.DEFAULT_UPDATE_INTERVAL : _b, _c = configWithDefaultsApplied.urlTemplate, urlTemplate = _c === void 0 ? $eBKYi.DEFAULT_URL_TEMPLATE : _c, _d = configWithDefaultsApplied.cache, cache = _d === void 0 ? $6e291c69f8e72436$var$noOpKeyValueCache : _d;
        this.cache = cache;
        this.cacheKey = "opt-datafile-" + sdkKey;
        this.isReadyPromiseSettled = false;
        this.readyPromiseResolver = function() {};
        this.readyPromiseRejecter = function() {};
        this.readyPromise = new Promise(function(resolve, reject) {
            _this.readyPromiseResolver = resolve;
            _this.readyPromiseRejecter = reject;
        });
        if (datafile) {
            this.currentDatafile = datafile;
            if (!sdkKey) this.resolveReadyPromise();
        } else this.currentDatafile = "";
        this.isStarted = false;
        this.datafileUrl = $e1zbx.sprintf(urlTemplate, sdkKey);
        this.emitter = new $6e291c69f8e72436$var$eventEmitter_1.default();
        this.autoUpdate = autoUpdate;
        if ($6e291c69f8e72436$var$isValidUpdateInterval(updateInterval)) this.updateInterval = updateInterval;
        else {
            $6e291c69f8e72436$var$logger.warn("Invalid updateInterval %s, defaulting to %s", updateInterval, $eBKYi.DEFAULT_UPDATE_INTERVAL);
            this.updateInterval = $eBKYi.DEFAULT_UPDATE_INTERVAL;
        }
        this.currentTimeout = null;
        this.currentRequest = null;
        this.backoffController = new $6e291c69f8e72436$var$backoffController_1.default();
        this.syncOnCurrentRequestComplete = false;
    }
    HttpPollingDatafileManager.prototype.get = function() {
        return this.currentDatafile;
    };
    HttpPollingDatafileManager.prototype.start = function() {
        if (!this.isStarted) {
            $6e291c69f8e72436$var$logger.debug("Datafile manager started");
            this.isStarted = true;
            this.backoffController.reset();
            this.setDatafileFromCacheIfAvailable();
            this.syncDatafile();
        }
    };
    HttpPollingDatafileManager.prototype.stop = function() {
        $6e291c69f8e72436$var$logger.debug("Datafile manager stopped");
        this.isStarted = false;
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
            this.currentTimeout = null;
        }
        this.emitter.removeAllListeners();
        if (this.currentRequest) {
            this.currentRequest.abort();
            this.currentRequest = null;
        }
        return Promise.resolve();
    };
    HttpPollingDatafileManager.prototype.onReady = function() {
        return this.readyPromise;
    };
    HttpPollingDatafileManager.prototype.on = function(eventName, listener) {
        return this.emitter.on(eventName, listener);
    };
    HttpPollingDatafileManager.prototype.onRequestRejected = function(err) {
        if (!this.isStarted) return;
        this.backoffController.countError();
        if (err instanceof Error) $6e291c69f8e72436$var$logger.error("Error fetching datafile: %s", err.message, err);
        else if (typeof err === "string") $6e291c69f8e72436$var$logger.error("Error fetching datafile: %s", err);
        else $6e291c69f8e72436$var$logger.error("Error fetching datafile");
    };
    HttpPollingDatafileManager.prototype.onRequestResolved = function(response) {
        if (!this.isStarted) return;
        if (typeof response.statusCode !== "undefined" && $6e291c69f8e72436$var$isSuccessStatusCode(response.statusCode)) this.backoffController.reset();
        else this.backoffController.countError();
        this.trySavingLastModified(response.headers);
        var datafile = this.getNextDatafileFromResponse(response);
        if (datafile !== "") {
            $6e291c69f8e72436$var$logger.info("Updating datafile from response");
            this.currentDatafile = datafile;
            this.cache.set(this.cacheKey, datafile);
            if (!this.isReadyPromiseSettled) this.resolveReadyPromise();
            else {
                var datafileUpdate = {
                    datafile: datafile
                };
                this.emitter.emit($6e291c69f8e72436$var$UPDATE_EVT, datafileUpdate);
            }
        }
    };
    HttpPollingDatafileManager.prototype.onRequestComplete = function() {
        if (!this.isStarted) return;
        this.currentRequest = null;
        if (!this.isReadyPromiseSettled && !this.autoUpdate) // We will never resolve ready, so reject it
        this.rejectReadyPromise(new Error("Failed to become ready"));
        if (this.autoUpdate && this.syncOnCurrentRequestComplete) this.syncDatafile();
        this.syncOnCurrentRequestComplete = false;
    };
    HttpPollingDatafileManager.prototype.syncDatafile = function() {
        var _this = this;
        var headers = {};
        if (this.lastResponseLastModified) headers["if-modified-since"] = this.lastResponseLastModified;
        $6e291c69f8e72436$var$logger.debug("Making datafile request to url %s with headers: %s", this.datafileUrl, function() {
            return JSON.stringify(headers);
        });
        this.currentRequest = this.makeGetRequest(this.datafileUrl, headers);
        var onRequestComplete = function onRequestComplete() {
            _this.onRequestComplete();
        };
        var onRequestResolved = function onRequestResolved(response) {
            _this.onRequestResolved(response);
        };
        var onRequestRejected = function onRequestRejected(err) {
            _this.onRequestRejected(err);
        };
        this.currentRequest.responsePromise.then(onRequestResolved, onRequestRejected).then(onRequestComplete, onRequestComplete);
        if (this.autoUpdate) this.scheduleNextUpdate();
    };
    HttpPollingDatafileManager.prototype.resolveReadyPromise = function() {
        this.readyPromiseResolver();
        this.isReadyPromiseSettled = true;
    };
    HttpPollingDatafileManager.prototype.rejectReadyPromise = function(err) {
        this.readyPromiseRejecter(err);
        this.isReadyPromiseSettled = true;
    };
    HttpPollingDatafileManager.prototype.scheduleNextUpdate = function() {
        var _this = this;
        var currentBackoffDelay = this.backoffController.getDelay();
        var nextUpdateDelay = Math.max(currentBackoffDelay, this.updateInterval);
        $6e291c69f8e72436$var$logger.debug("Scheduling sync in %s ms", nextUpdateDelay);
        this.currentTimeout = setTimeout(function() {
            if (_this.currentRequest) _this.syncOnCurrentRequestComplete = true;
            else _this.syncDatafile();
        }, nextUpdateDelay);
    };
    HttpPollingDatafileManager.prototype.getNextDatafileFromResponse = function(response) {
        $6e291c69f8e72436$var$logger.debug("Response status code: %s", response.statusCode);
        if (typeof response.statusCode === "undefined") return "";
        if (response.statusCode === 304) return "";
        if ($6e291c69f8e72436$var$isSuccessStatusCode(response.statusCode)) return response.body;
        return "";
    };
    HttpPollingDatafileManager.prototype.trySavingLastModified = function(headers) {
        var lastModifiedHeader = headers["last-modified"] || headers["Last-Modified"];
        if (typeof lastModifiedHeader !== "undefined") {
            this.lastResponseLastModified = lastModifiedHeader;
            $6e291c69f8e72436$var$logger.debug("Saved last modified header value from response: %s", this.lastResponseLastModified);
        }
    };
    HttpPollingDatafileManager.prototype.setDatafileFromCacheIfAvailable = function() {
        var _this = this;
        this.cache.get(this.cacheKey).then(function(datafile) {
            if (_this.isStarted && !_this.isReadyPromiseSettled && datafile !== "") {
                $6e291c69f8e72436$var$logger.debug("Using datafile from cache");
                _this.currentDatafile = datafile;
                _this.resolveReadyPromise();
            }
        });
    };
    return HttpPollingDatafileManager;
}();
module.exports.default = $6e291c69f8e72436$var$HttpPollingDatafileManager;

});
parcelRegister("1J7cm", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $141f93d63422d470$var$EventEmitter = /** @class */ function() {
    function EventEmitter() {
        this.listeners = {};
        this.listenerId = 1;
    }
    EventEmitter.prototype.on = function(eventName, listener) {
        var _this = this;
        if (!this.listeners[eventName]) this.listeners[eventName] = {};
        var currentListenerId = String(this.listenerId);
        this.listenerId++;
        this.listeners[eventName][currentListenerId] = listener;
        return function() {
            if (_this.listeners[eventName]) delete _this.listeners[eventName][currentListenerId];
        };
    };
    EventEmitter.prototype.emit = function(eventName, arg) {
        var listeners = this.listeners[eventName];
        if (listeners) Object.keys(listeners).forEach(function(listenerId) {
            var listener = listeners[listenerId];
            listener(arg);
        });
    };
    EventEmitter.prototype.removeAllListeners = function() {
        this.listeners = {};
    };
    return EventEmitter;
}();
module.exports.default = $141f93d63422d470$var$EventEmitter; // TODO: Create a typed event emitter for use in TS only (not JS)

});

parcelRegister("lcyoc", function(module, exports) {
"use strict";
/**
 * Copyright 2019-2020, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eBKYi = parcelRequire("eBKYi");
function $f6f564f801478aa4$var$randomMilliseconds() {
    return Math.round(Math.random() * 1000);
}
var $f6f564f801478aa4$var$BackoffController = /** @class */ function() {
    function BackoffController() {
        this.errorCount = 0;
    }
    BackoffController.prototype.getDelay = function() {
        if (this.errorCount === 0) return 0;
        var baseWaitSeconds = $eBKYi.BACKOFF_BASE_WAIT_SECONDS_BY_ERROR_COUNT[Math.min($eBKYi.BACKOFF_BASE_WAIT_SECONDS_BY_ERROR_COUNT.length - 1, this.errorCount)];
        return baseWaitSeconds * 1000 + $f6f564f801478aa4$var$randomMilliseconds();
    };
    BackoffController.prototype.countError = function() {
        if (this.errorCount < $eBKYi.BACKOFF_BASE_WAIT_SECONDS_BY_ERROR_COUNT.length - 1) this.errorCount++;
    };
    BackoffController.prototype.reset = function() {
        this.errorCount = 0;
    };
    return BackoffController;
}();
module.exports.default = $f6f564f801478aa4$var$BackoffController;

});





function $c4a7a5f634ef03e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $c4a7a5f634ef03e9$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $c4a7a5f634ef03e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $c4a7a5f634ef03e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $aRmx5 = parcelRequire("aRmx5");
var $b363ce9b7c24569d$var$extendStatics = function extendStatics1(d, b) {
    $b363ce9b7c24569d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b363ce9b7c24569d$var$extendStatics(d, b);
};
function $b363ce9b7c24569d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b363ce9b7c24569d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b363ce9b7c24569d$export$18ce0697a983be9b = function __assign1() {
    $b363ce9b7c24569d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b363ce9b7c24569d$export$18ce0697a983be9b.apply(this, arguments);
};
function $b363ce9b7c24569d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b363ce9b7c24569d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b363ce9b7c24569d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b363ce9b7c24569d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b363ce9b7c24569d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b363ce9b7c24569d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aRmx5._)(x)) === "symbol" ? x : "".concat(x);
}
function $b363ce9b7c24569d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $aRmx5._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b363ce9b7c24569d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b363ce9b7c24569d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b363ce9b7c24569d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b363ce9b7c24569d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b363ce9b7c24569d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b363ce9b7c24569d$export$45d3717a4c69092e(o, m, p);
}
function $b363ce9b7c24569d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b363ce9b7c24569d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b363ce9b7c24569d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b363ce9b7c24569d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b363ce9b7c24569d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b363ce9b7c24569d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b363ce9b7c24569d$export$10c90e4f7922046c(v) {
    return this instanceof $b363ce9b7c24569d$export$10c90e4f7922046c ? (this.v = v, this) : new $b363ce9b7c24569d$export$10c90e4f7922046c(v);
}
function $b363ce9b7c24569d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b363ce9b7c24569d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b363ce9b7c24569d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b363ce9b7c24569d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b363ce9b7c24569d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b363ce9b7c24569d$export$19a8beecd37a4c45 === "function" ? $b363ce9b7c24569d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b363ce9b7c24569d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b363ce9b7c24569d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b363ce9b7c24569d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b363ce9b7c24569d$export$45d3717a4c69092e(result, mod, k);
    }
    $b363ce9b7c24569d$var$__setModuleDefault(result, mod);
    return result;
}
function $b363ce9b7c24569d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b363ce9b7c24569d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b363ce9b7c24569d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b363ce9b7c24569d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b363ce9b7c24569d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b363ce9b7c24569d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b363ce9b7c24569d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b363ce9b7c24569d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b363ce9b7c24569d$export$2e2bcd8739ae039 = {
    __extends: $b363ce9b7c24569d$export$a8ba968b8961cb8a,
    __assign: $b363ce9b7c24569d$export$18ce0697a983be9b,
    __rest: $b363ce9b7c24569d$export$3c9a16f847548506,
    __decorate: $b363ce9b7c24569d$export$29e00dfd3077644b,
    __param: $b363ce9b7c24569d$export$d5ad3fd78186038f,
    __metadata: $b363ce9b7c24569d$export$f1db080c865becb9,
    __awaiter: $b363ce9b7c24569d$export$1050f835b63b671e,
    __generator: $b363ce9b7c24569d$export$67ebef60e6f28a6,
    __createBinding: $b363ce9b7c24569d$export$45d3717a4c69092e,
    __exportStar: $b363ce9b7c24569d$export$f33643c0debef087,
    __values: $b363ce9b7c24569d$export$19a8beecd37a4c45,
    __read: $b363ce9b7c24569d$export$8d051b38c9118094,
    __spread: $b363ce9b7c24569d$export$afc72e2116322959,
    __spreadArrays: $b363ce9b7c24569d$export$6388937ca91ccae8,
    __spreadArray: $b363ce9b7c24569d$export$1216008129fb82ed,
    __await: $b363ce9b7c24569d$export$10c90e4f7922046c,
    __asyncGenerator: $b363ce9b7c24569d$export$e427f37a30a4de9b,
    __asyncDelegator: $b363ce9b7c24569d$export$bbd80228419bb833,
    __asyncValues: $b363ce9b7c24569d$export$e3b29a3d6162315f,
    __makeTemplateObject: $b363ce9b7c24569d$export$4fb47efe1390b86f,
    __importStar: $b363ce9b7c24569d$export$c21735bcef00d192,
    __importDefault: $b363ce9b7c24569d$export$da59b14a69baef04,
    __classPrivateFieldGet: $b363ce9b7c24569d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b363ce9b7c24569d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b363ce9b7c24569d$export$81fdc39f203e4e04,
    __addDisposableResource: $b363ce9b7c24569d$export$88ac25d8e944e405,
    __disposeResources: $b363ce9b7c24569d$export$8f076105dc360e92
};



function $2cd0ae698556872c$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $cba4dd0b4e9e0b8d$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $2cd0ae698556872c$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}



/**
 * Retrieves the search portion of the current URL.
 * @returns {string} The search portion of the URL.
 */ function $7df447687cfd5336$export$c0166938e4a3a33f() {
    return window.location.search;
}
function $7df447687cfd5336$export$1cfafeee2987818b() {
    return window.location.href;
}
function $7df447687cfd5336$export$8921c544a68ce4b6() {
    return window.location.host;
}


function $e50983d18ba5ea84$export$aa229565c230a2b() {
    return "prod";
}
function $e50983d18ba5ea84$export$822e30597d1d36ab() {
    var _getLocationHost;
    return $e50983d18ba5ea84$export$aa229565c230a2b() !== "prod" || ((_getLocationHost = (0, $7df447687cfd5336$export$8921c544a68ce4b6)()) === null || _getLocationHost === void 0 ? void 0 : _getLocationHost.includes("preview"));
}
function $e50983d18ba5ea84$export$fdcb811213c4b723() {
    return $e50983d18ba5ea84$export$aa229565c230a2b() === "prod" ? "SxQDAzMj39398zmwkDCG47" : "Lt8wynKLp1jWEaFeVcsM48";
}


/**
 *  Gets cookie values from the document and parses them to
 */ function $587653b2952c74c4$export$97131b3b5327c27f() {
    return Object.fromEntries(document.cookie.split("; ").map(function(x) {
        return x.split(/=(.+)/);
    }));
}
function $587653b2952c74c4$export$4be65e66cfa2648a(cookieName) {
    var _cookies_cookieName;
    return (_cookies_cookieName = $587653b2952c74c4$export$97131b3b5327c27f()[cookieName]) !== null && _cookies_cookieName !== void 0 ? _cookies_cookieName : "";
}
function $587653b2952c74c4$export$82afab29fb1c4915(cookieName) {
    var jar = $587653b2952c74c4$export$97131b3b5327c27f();
    if (!jar[cookieName]) return {};
    return Object.fromEntries(jar[cookieName].split("&").map(function(x) {
        return x.split("=");
    }));
}
function $587653b2952c74c4$export$faadd2632dd035b1(cookieValue) {
    if (!cookieValue) return "";
    return decodeURIComponent(cookieValue.replace(/\+/g, " "));
}



var $a3320fc1d1e4336a$export$32e4735279bb5579 = {
    travelAgent: "travelAgent",
    easybiz: "easybiz",
    default: "default"
};
var $a3320fc1d1e4336a$export$26e70f1a590c2131 = function() {
    var travelAgentCookie = (0, $587653b2952c74c4$export$82afab29fb1c4915)("AS%5FPROMO%5FLOGIN");
    var easyBizCookie = (0, $587653b2952c74c4$export$82afab29fb1c4915)("AS%5FACNT%5FCOMPANY");
    var locationSearch = (0, $7df447687cfd5336$export$c0166938e4a3a33f)();
    var visitorType = $a3320fc1d1e4336a$export$32e4735279bb5579.default;
    var overrideMatch;
    if ((0, $e50983d18ba5ea84$export$822e30597d1d36ab)() && (locationSearch === null || locationSearch === void 0 ? void 0 : locationSearch.match(/visitor=([^&]+)/))) {
        overrideMatch = locationSearch === null || locationSearch === void 0 ? void 0 : locationSearch.match(/visitor=([^&]+)/);
        var overrideVisitor = overrideMatch.length > 1 && $a3320fc1d1e4336a$export$32e4735279bb5579[overrideMatch[1]];
        return overrideVisitor || $a3320fc1d1e4336a$export$32e4735279bb5579.default;
    }
    if (locationSearch && /lid=TAfooter/i.test(locationSearch) || (travelAgentCookie === null || travelAgentCookie === void 0 ? void 0 : travelAgentCookie.STATUS) === "OK" && (travelAgentCookie === null || travelAgentCookie === void 0 ? void 0 : travelAgentCookie.TYPE) === "TRAVELAGENT") visitorType = $a3320fc1d1e4336a$export$32e4735279bb5579.travelAgent;
    else if (easyBizCookie === null || easyBizCookie === void 0 ? void 0 : easyBizCookie.COMPANYNAME) visitorType = $a3320fc1d1e4336a$export$32e4735279bb5579.easybiz;
    return visitorType;
};




function $c8f06e0ed0814ad0$var$generateHost() {
    var releaseEnvironment = (0, $e50983d18ba5ea84$export$aa229565c230a2b)();
    // use QA if in preview
    if ((0, $e50983d18ba5ea84$export$aa229565c230a2b)() === "prod" && (0, $e50983d18ba5ea84$export$822e30597d1d36ab)()) releaseEnvironment = "qa";
    if (releaseEnvironment) return "https://contentcdn".concat(releaseEnvironment, "acct.blob.core.windows.net/online-chat");
    else return "http://localhost:5000";
}
var $c8f06e0ed0814ad0$var$genResOptions = function(param) {
    var host = param.host, visitorName = param.visitorName, mileagePlanNumber = param.mileagePlanNumber;
    return {
        title: "Alaska Air",
        profiles: (0, $e50983d18ba5ea84$export$822e30597d1d36ab)() ? "GenResQA--Chat" : "ChatRes",
        theme: "".concat(host, "/index.css"),
        fields: {
            name: {
                value: visitorName !== null && visitorName !== void 0 ? visitorName : "",
                show: true,
                label: "Name"
            },
            email: {
                value: "",
                show: false,
                label: "Email"
            },
            "Mileage Number": {
                value: mileagePlanNumber !== null && mileagePlanNumber !== void 0 ? mileagePlanNumber : "",
                show: true,
                label: "Mileage Plan Number"
            },
            question: {
                value: "",
                show: true,
                label: "How can we help?"
            }
        }
    };
};
var $c8f06e0ed0814ad0$var$easyBizOptions = function(param) {
    var host = param.host, visitorName = param.visitorName, companyName = param.companyName, mileagePlanNumber = param.mileagePlanNumber;
    return {
        title: "Alaska Air EasyBiz",
        profiles: (0, $e50983d18ba5ea84$export$822e30597d1d36ab)() ? "EasyBizQA--Chat" : "ChatEasyBiz",
        theme: "".concat(host, "/index.css"),
        fields: {
            name: {
                value: visitorName !== null && visitorName !== void 0 ? visitorName : "",
                show: true,
                label: "Name"
            },
            email: {
                value: "",
                show: false,
                label: "Email"
            },
            companyName: {
                value: companyName !== null && companyName !== void 0 ? companyName : "",
                show: true,
                label: "Company Name"
            },
            "Mileage Number": {
                value: mileagePlanNumber !== null && mileagePlanNumber !== void 0 ? mileagePlanNumber : "",
                show: true,
                label: "Mileage Plan Number"
            },
            question: {
                value: "",
                show: true,
                label: "How can we help?"
            }
        }
    };
};
var $c8f06e0ed0814ad0$var$travelAgentOptions = function(param) {
    var host = param.host, visitorName = param.visitorName, travelAgentNumber = param.travelAgentNumber, companyName = param.companyName;
    return {
        title: "Alaska Air TravelAgent",
        profiles: (0, $e50983d18ba5ea84$export$822e30597d1d36ab)() ? "TravelAgentQA--Chat" : "ChatTravelAgency",
        theme: "".concat(host, "/index.css"),
        fields: {
            name: {
                value: visitorName !== null && visitorName !== void 0 ? visitorName : "",
                show: true,
                label: "Name"
            },
            email: {
                value: "",
                show: false,
                label: "Email"
            },
            iataNumber: {
                value: travelAgentNumber !== null && travelAgentNumber !== void 0 ? travelAgentNumber : "",
                show: true,
                label: "IATA Number"
            },
            companyName: {
                value: companyName !== null && companyName !== void 0 ? companyName : "",
                show: true,
                label: "Company Name"
            },
            question: {
                value: "",
                show: true,
                label: "How can we help?"
            }
        }
    };
};
/**
 * Returns options object prepopulated with information knwon about the user
 *
 * @param {*} visitorType type of visitor to return options for
 */ var $c8f06e0ed0814ad0$var$getVisitorOptions = function(visitorType) {
    var host = $c8f06e0ed0814ad0$var$generateHost();
    var ASNameCookie = (0, $587653b2952c74c4$export$82afab29fb1c4915)("AS%5FNAME");
    var easyBizCookie = (0, $587653b2952c74c4$export$82afab29fb1c4915)("AS%5FACNT%5FCOMPANY");
    var travelAgentCookie = (0, $587653b2952c74c4$export$82afab29fb1c4915)("AS%5FPROMO%5FLOGIN");
    var firstName = (0, $587653b2952c74c4$export$faadd2632dd035b1)(ASNameCookie.FN);
    var lastName = (0, $587653b2952c74c4$export$faadd2632dd035b1)(ASNameCookie.LN);
    var visitorName = firstName + " " + lastName;
    var _ASNameCookie_MP;
    var mileagePlanNumber = (_ASNameCookie_MP = ASNameCookie.MP) !== null && _ASNameCookie_MP !== void 0 ? _ASNameCookie_MP : "";
    var companyName; // used in easybiz and travel agent path
    var travelAgentNumber; // used by travel agent
    if (!(0, $a3320fc1d1e4336a$export$32e4735279bb5579)[visitorType]) visitorType = (0, $a3320fc1d1e4336a$export$32e4735279bb5579).default;
    switch(visitorType){
        case (0, $a3320fc1d1e4336a$export$32e4735279bb5579).easybiz:
            companyName = (0, $587653b2952c74c4$export$faadd2632dd035b1)(easyBizCookie.COMPANYNAME);
            return $c8f06e0ed0814ad0$var$easyBizOptions({
                host: host,
                visitorName: visitorName,
                companyName: companyName,
                mileagePlanNumber: mileagePlanNumber
            });
        case (0, $a3320fc1d1e4336a$export$32e4735279bb5579).travelAgent:
            companyName = (0, $587653b2952c74c4$export$faadd2632dd035b1)(easyBizCookie.COMPANYNAME);
            var _travelAgentCookie_TANUMBER;
            travelAgentNumber = (_travelAgentCookie_TANUMBER = travelAgentCookie.TANUMBER) !== null && _travelAgentCookie_TANUMBER !== void 0 ? _travelAgentCookie_TANUMBER : "";
            return $c8f06e0ed0814ad0$var$travelAgentOptions({
                host: host,
                visitorName: visitorName,
                travelAgentNumber: travelAgentNumber,
                companyName: companyName
            });
        case (0, $a3320fc1d1e4336a$export$32e4735279bb5579).default:
        default:
            return $c8f06e0ed0814ad0$var$genResOptions({
                host: host,
                visitorName: visitorName,
                mileagePlanNumber: mileagePlanNumber
            });
    }
};
var $c8f06e0ed0814ad0$export$2e2bcd8739ae039 = $c8f06e0ed0814ad0$var$getVisitorOptions;









var $9ck0s = parcelRequire("9ck0s");

(0, (/*@__PURE__*/$parcel$interopDefault($9ck0s))).setLogger(null);
var $8768bf6e4a559bfb$export$57d509f66e500e21 = "open-chat";
var $8768bf6e4a559bfb$var$optimizelyUserIdCookieName = "optimizelyEndUserId";
/**
 * Determine if current device supports local storage
 *
 * @returns {boolean} if current device supports local storage
 */ var $8768bf6e4a559bfb$var$hasLocalStorage = function() {
    try {
        window.localStorage.setItem("test", "test");
        window.localStorage.removeItem("test");
        return true;
    } catch (e) {
        return false;
    }
};
/**
 * Using the five9 local storage data, determine if the chat widget is in progress
 *
 * @returns {boolean} if Five9 chat is active in local storage
 */ var $8768bf6e4a559bfb$var$isFive9ChatInProgress = function() {
    var active = false;
    if ($8768bf6e4a559bfb$var$hasLocalStorage()) for(var i = 0; i < localStorage.length; ++i){
        var key = window.localStorage.key(i);
        // the localStorage key for five9 has some random characters on the end, so use startWith to find it
        if (key.startsWith("f9-chat-console")) {
            var f9State = void 0;
            // attempt to convert the stored string into a json object
            try {
                f9State = JSON.parse(window.localStorage.getItem(key));
                active = true;
            } catch (error) {
                f9State = {};
            }
            // if we have no session id OR we do have a session ID but the "step" is "Finished", hide the chat
            if (!f9State || !f9State.session || !f9State.session.id || f9State.session.id.length == 0 || f9State.step == "Finished") active = false;
        }
    }
    return active;
};
var $8768bf6e4a559bfb$export$636b4fb4514f1549 = function() {
    var _ref = (0, $c4a7a5f634ef03e9$export$7c398597f8905a1)(function() {
        var updateIntervalMs, optimizelyClientInstance, success;
        return (0, $b363ce9b7c24569d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    updateIntervalMs = 300000; // 5 minutes in milliseconds
                    optimizelyClientInstance = (0, (/*@__PURE__*/$parcel$interopDefault($9ck0s))).createInstance({
                        autoUpdate: true,
                        updateInterval: updateIntervalMs,
                        sdkKey: (0, $e50983d18ba5ea84$export$fdcb811213c4b723)
                    });
                    return [
                        4,
                        optimizelyClientInstance.onReady({
                            timeout: 10000
                        }).then(function(result) {
                            // if optimizely datafile download failed (ie. takes more than 10 seconds, network error), be optimistic and say online chat is available
                            if (!result.success) return true;
                            var _obj;
                            var featureToCheck = (_obj = {}, (0, $2cd0ae698556872c$export$1e71eb4bef00f6b0)(_obj, (0, $a3320fc1d1e4336a$export$32e4735279bb5579).default, "online_chat"), (0, $2cd0ae698556872c$export$1e71eb4bef00f6b0)(_obj, (0, $a3320fc1d1e4336a$export$32e4735279bb5579).easybiz, "online_chat_easybiz"), (0, $2cd0ae698556872c$export$1e71eb4bef00f6b0)(_obj, (0, $a3320fc1d1e4336a$export$32e4735279bb5579).travelAgent, "online_chat_travel_agent"), _obj)[(0, $a3320fc1d1e4336a$export$26e70f1a590c2131)()];
                            var userId = (0, $587653b2952c74c4$export$4be65e66cfa2648a)($8768bf6e4a559bfb$var$optimizelyUserIdCookieName);
                            // if there is no optimizely cookie, be optimistic and say online chat is available
                            return userId ? optimizelyClientInstance.isFeatureEnabled(featureToCheck, userId) : true;
                        })
                    ];
                case 1:
                    success = _state.sent();
                    return [
                        2,
                        success
                    ];
            }
        });
    });
    return function isOnlineChatAvailable() {
        return _ref.apply(this, arguments);
    };
}();
var $8768bf6e4a559bfb$export$512acdf6f392798b = function() {
    var chatOpeningElements = document.body.getElementsByClassName($8768bf6e4a559bfb$export$57d509f66e500e21);
    return chatOpeningElements.length > 0;
};
var $8768bf6e4a559bfb$export$206e5647bc712a7f = function() {
    var _ref = (0, $c4a7a5f634ef03e9$export$7c398597f8905a1)(function() {
        var _tmp, _tmp1;
        return (0, $b363ce9b7c24569d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = $8768bf6e4a559bfb$var$isFive9ChatInProgress();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    _tmp1 = $8768bf6e4a559bfb$export$512acdf6f392798b();
                    if (!_tmp1) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $8768bf6e4a559bfb$export$636b4fb4514f1549()
                    ];
                case 1:
                    _tmp1 = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp = _tmp1;
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function shouldLoadOnlineChat() {
        return _ref.apply(this, arguments);
    };
}();


/**
 * Loads Five9 Widget script into page dom body
 *
 * @returns {Promise} Promise that resolves once Five9 Widget script is loaded onto page dom
 */ var $59853d51403442fa$var$loadFive9Widget = function() {
    return new Promise(function(resolve, reject) {
        var onlineChatScript = document.createElement("script");
        onlineChatScript.type = "text/javascript";
        onlineChatScript.src = "https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js";
        onlineChatScript.onload = resolve;
        onlineChatScript.onerror = reject;
        document.body.appendChild(onlineChatScript);
    });
};
/**
 * Helper function to set the display style on the five9 frame, used to show and hide the frame
 *
 * @param {String} displayStyle display style to set to frame
 */ var $59853d51403442fa$var$setFive9FrameDisplayStyle = function(displayStyle) {
    var five9Frame = document.getElementsByClassName("five9-frame");
    if (five9Frame && five9Frame[0]) five9Frame[0].style.display = displayStyle;
};
/**
 * Eventlistener that will show the entire frame and then trigger a click event to maximize the chat frame
 *
 * @param {Event} event event object to pass into listener
 */ var $59853d51403442fa$var$maximizeChat = function(event) {
    event.preventDefault();
    $59853d51403442fa$var$setFive9FrameDisplayStyle("block");
    var maximizeButton = document.getElementById("five9-maximize-button");
    if (maximizeButton) maximizeButton.click();
};
var $59853d51403442fa$export$977e66f4a76c06c8 = function() {
    var _ref = (0, $c4a7a5f634ef03e9$export$7c398597f8905a1)(function() {
        var visitorType, currentVisitorOptions, options, chatStartElement;
        return (0, $b363ce9b7c24569d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $59853d51403442fa$var$loadFive9Widget()
                    ];
                case 1:
                    _state.sent();
                    visitorType = (0, $a3320fc1d1e4336a$export$26e70f1a590c2131)();
                    currentVisitorOptions = (0, $c8f06e0ed0814ad0$export$2e2bcd8739ae039)(visitorType);
                    options = (0, $cba4dd0b4e9e0b8d$export$581ff339ea0ba762)({
                        rootUrl: "https://app.five9.com/consoles/",
                        type: "chat",
                        tenant: "Alaska Airlines.",
                        showProfiles: false,
                        autostart: false,
                        surveyOptions: {
                            showComment: false,
                            requireComment: false
                        },
                        playSoundOnMessage: true,
                        allowCustomerToControlSoundPlay: true,
                        showEmailButton: false,
                        hideDuringAfterHours: false,
                        useBusinessHours: true,
                        showPrintButton: false,
                        allowUsabilityMenu: false,
                        enableCallback: false,
                        callbackList: "",
                        done: function() {},
                        allowRequestLiveAgent: false
                    }, currentVisitorOptions);
                    // Add five9 chat widget to the page
                    // eslint-disable-next-line no-undef
                    Five9SocialWidget.addWidget(options);
                    // when a "start chat" link is clicked, show the chat frame and automatically maximize it
                    chatStartElement = document.getElementsByClassName((0, $8768bf6e4a559bfb$export$57d509f66e500e21))[0];
                    if (chatStartElement) chatStartElement.addEventListener("click", $59853d51403442fa$var$maximizeChat);
                    return [
                        2
                    ];
            }
        });
    });
    return function initOnlineChat() {
        return _ref.apply(this, arguments);
    };
}();


var $d2cfa0284ee540db$var$setAvailabilityStyles = function(isChatAvailable) {
    var styleElement = document.createElement("style");
    styleElement.textContent = "\n.show-when-chat-available {\n  display: ".concat(isChatAvailable ? "block" : "none", ";\n}\n.hide-when-chat-available {\n  display: ").concat(isChatAvailable ? "none" : "block", ";\n}\n.show-when-chat-unavailable {\n  display: ").concat(isChatAvailable ? "none" : "block", ";\n}\n.hide-when-chat-unavailable {\n  display: ").concat(isChatAvailable ? "block" : "none", ";\n}\n").replace(/((\r|\n|\r\n)\s*|\s+)/g, " ");
    document.body.appendChild(styleElement);
};
var $d2cfa0284ee540db$export$2e2bcd8739ae039 = $d2cfa0284ee540db$var$setAvailabilityStyles;



(0, $c4a7a5f634ef03e9$export$7c398597f8905a1)(function() {
    return (0, $b363ce9b7c24569d$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0, $8768bf6e4a559bfb$export$206e5647bc712a7f)()
                ];
            case 1:
                if (!_state.sent()) return [
                    3,
                    3
                ];
                (0, $d2cfa0284ee540db$export$2e2bcd8739ae039)(true);
                return [
                    4,
                    (0, $59853d51403442fa$export$977e66f4a76c06c8)()
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                (0, $d2cfa0284ee540db$export$2e2bcd8739ae039)(false);
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
})();

})();
//# sourceMappingURL=index.js.map
